var isRegionalSettingEnabled = typeof RegionalSettingEnable != "undefined" && RegionalSettingEnable;
(function () {
    'use strict';

    var app = angular.module('SMART2');


    window.onmousedown = function (e) {
        if ($(e.target).closest('.smart-table-cell-template').length > 0) {
            window.isSmartTableCellClicked = true;
        }

        //	If autosuggest option is not clicked, allow scope to be cleared
        if (window.lastActiveCellScope && ($(e.target).closest('.daterangepicker').length > 0 || $(e.target).closest('.autocomplete-suggestion').length > 0 ||
        $(e.target).closest('.autocomplete-suggestions').length > 0 || $(e.target).closest('.modal').length > 0 || $(e.target).closest('.lean-overlay').length > 0)) {
            return;
        }

        //	Clear and update last rendered cell when selection or tree icon is clicked
        if ($(e.target).closest('.smart-table-row-cell').length == 0 || $(e.target).closest('.smart-table-icon-holder').length > 0) {
            if (window.lastActiveCellScope) {
                window.lastActiveCellScope.stopEdit();
                window.lastActiveCellScope = undefined;
            }
            return;
        }
    };


    window.focusHandler = function (element) {
        element.focus(function () {
            setTimeout((function (el) {
                var strLength = el.value.length;
                return function () {
                    if (el.setSelectionRange !== undefined) {
                        el.setSelectionRange(strLength, strLength);
                    }
                    else {
                        $(el).val(el.value);
                    }
                }
            }(this)), 0);
        });
    };


    //  To handle date picker control issue
    setTimeout(function () {
        window.onkeydown = function (e) {
            if ($(e.target).is('body') && window.lastActiveCellScope &&
                window.lastActiveCellScope.column.attributes && window.lastActiveCellScope.column.attributes.type == 'date') {
                window.lastActiveCellScope.onElementKeyDown(e);
                return false;
            }
        };
    }, 500);


    function getObjectValue(obj, keys) {
        try {
            var arr = keys.split('.');
            while (arr.length) {
                obj = obj[arr.shift()];
            }
        }
        catch (e) { }
        return obj;
    };

    function getObjectValueForAutoSuggest(obj, keys) {
        var arr = keys.split('.');
        if (arr.length > 1) {
            arr.splice(arr.length - 1, 1);
            return getObjectValue(obj, arr.join('.'));
        }
        return obj[arr[0]];
    };

    function setObjectValue(obj, keys, value) {
        try {
            var arr = keys.split('.');
            if (arr.length == 1) {
                obj[arr[0]] = value;
            }
            else {
                var obj = obj[arr[0]];
                arr.shift();
                var keys = arr.join('.');
                setObjectValue(obj, keys, value);
            }
        }
        catch (e) { }
    };

    function updateCell(obj, keys, value) {
        if (!angular.isObject(value)) {
            setObjectValue(obj, keys, value);
            return;
        }
        else if (!angular.isObject(obj[keys.split('.')[0]]) && angular.isObject(value)) {
            setObjectValue(obj, keys, value[keys.split('.')[0]]);
            return;
        }
        angular.extend(obj[keys.split('.')[0]], value);
    };

    function getFormattedData(data, displayFormat) {
        if (!data || data.length == 0) {
            return [];
        }
        for (var i = 0; i < data.length; i++) {
            var str = displayFormat;
            try {
                var parentSplit = str.split('{');
                for (var j = 0; j < parentSplit.length; j++) {
                    var childSplit = parentSplit[j].split('}');
                    for (var k = 0; k < childSplit.length; k++) {
                        if (childSplit[k].indexOf('.') > 0 || data[i].hasOwnProperty(childSplit[k])) {
                            str = str.replace(new RegExp("{" + childSplit[k] + "}", "ig"), eval('data[i].' + childSplit[k]));
                        }
                    }
                }
            }
            catch (e) { }
            data[i].value = str.trim();
        }
        return data;
    };

    function getDisplayData(data, displayFormat) {
        if (data == undefined || data == null || data == '') {
            return '';
        }
        var str = displayFormat, evalResult, evaluatedKeysCounter = 0, nullKeysCounter = 0;
        try {
            var parentSplit = str.split('{');
            for (var j = 0; j < parentSplit.length; j++) {
                var childSplit = parentSplit[j].split('}');
                for (var k = 0; k < childSplit.length; k++) {
                    if (childSplit[k].indexOf('.') > 0 || data.hasOwnProperty(childSplit[k])) {
                        evalResult = eval('data.' + childSplit[k]);
                        evaluatedKeysCounter++;
                        if (evalResult == undefined || evalResult == null || (evalResult + '').trim().length == 0) {
                            evalResult = '';
                            nullKeysCounter++;
                        }
                        str = str.replace(new RegExp("{" + childSplit[k] + "}", "ig"), evalResult);
                    }
                }
            }
            if (evaluatedKeysCounter == nullKeysCounter) {
                str = '';
            }
        }
        catch (e) { }
        return str === undefined || str === null || str === 'undefined' || str === 'null' ? '' : str;
    };

    function convertNumberToFixed(number, minPrecision, maxPrecision) {
        var arrTmpInputValue, tmpStrAfterPrecision;
        arrTmpInputValue = (number + '').split('.');

        if (arrTmpInputValue.length > 1) {
            tmpStrAfterPrecision = arrTmpInputValue[arrTmpInputValue.length - 1];
            if (maxPrecision > 0 && tmpStrAfterPrecision.length >= maxPrecision) {
                return number.toString().match(new RegExp('^-?\\d+(?:\.\\d{0,' + (maxPrecision || -1) + '})?'))[0];
            }
            else if (minPrecision > 0 && tmpStrAfterPrecision.length <= minPrecision) {
                return Number(Math.round(number + 'e' + minPrecision) + 'e-' + minPrecision);
            }
            else {
                return number;
            }
        }
        else {
            return Number(Math.round(number + 'e' + minPrecision) + 'e-' + minPrecision);
        }
    };

    function sortSmartTableData(data, column, isAscending, translate) {
        return data.sort(function (a, b) {
            var strOne = getObjectValue(a, column.field);
            var strTwo = getObjectValue(b, column.field);

            var intOne = parseFloat(strOne);
            var intTwo = parseFloat(strTwo);

            if (isNaN(intOne) && isNaN(intTwo)) {
                try {
                    if (column.enableTranslation) {
                        strOne = translate.instant(strOne);
                        strTwo = translate.instant(strTwo);
                    }
                    strOne = strOne.toLowerCase();
                    strTwo = strTwo.toLowerCase();
                }
                catch (e) { }
                return strOne > strTwo ? (isAscending ? -1 : 1) : (strOne < strTwo ? (isAscending ? 1 : -1) : 0);
            }
            else if (isNaN(intOne)) {
                return isAscending ? -1 : 1;
            }
            else if (isNaN(intTwo)) {
                return isAscending ? 1 : -1;
            }
            else {
                return intOne > intTwo ? (isAscending ? -1 : 1) : (intOne < intTwo ? (isAscending ? 1 : -1) : 0);
            }
        });
    };

    app.filter('smartTableFilter', ['$filter', '$translate', 'smartTableUtils', function ($filter, $translate, smartTableUtils) {
        var isParentRowToBeDisplayed = function (data, index, filters) {
            var result = false;

            for (var i = index + 1; i < data.length; i++) {
                if (data[i].$$treeLevel == 0) {
                    break;
                }
                else {
                    for (var j = 0; j < filters.length; j++) {
                        if (((getObjectValue(data[i], filters[j].filterKey) + "").toLowerCase()).indexOf((filters[j].filterText + "").toLowerCase()) > -1) {
                            result = true;
                            break;
                        }
                    }
                }
            }

            return result;
        };

        var getChildrenNodes = function (data, nodeIndex) {
            var tmpRows = $filter('filter')(data, function (row, i) {
                return row.$$treeLevel > 0 && row.$$nodeIndex == nodeIndex;
            });
            tmpRows = $filter('orderBy')(tmpRows, '$$treeLevel', false);
            return tmpRows;
        };

        return function (data, filters, sortState, enableTreeView, showTreeView, offset, limit, useExternalPagination, smartTableId) {
            var outputData;
            if (filters.length == 0) {
                if (data) {
                    if (enableTreeView) {
                        var nodeIndex = -1;
                        var parentIndex = -1;

                        outputData = $filter('filter')(data, function (row, index) {
                            if (row.$$treeLevel == 0) {
                                nodeIndex++;
                                parentIndex = index;
                                row.$$enableTreeView = false;
                            }
                            else {
                                try {
                                    data[parentIndex].$$enableTreeView = true;
                                }
                                catch (e) { }
                            }

                            row.$$nodeIndex = nodeIndex;
                            row.$$index = (useExternalPagination ? offset : 0) + index;
                            row.$$parentIndex = parentIndex;
                            row.$$isExpanded = data[parentIndex].$$isExpanded || !showTreeView;
                            row.$$isSelectable = angular.isUndefined(row.$$isSelectable) ? true : row.$$isSelectable;

                            return row.$$treeLevel == 0 || row.$$isExpanded;
                        });
                    }
                    else {
                        outputData = $filter('filter')(data, function (row, index) {
                            row.$$index = (useExternalPagination ? offset : 0) + index;
                            row.$$isSelectable = angular.isUndefined(row.$$isSelectable) ? true : row.$$isSelectable;
                            return true;
                        });
                    }
                }
                else {
                    outputData = [];
                }
            }
            else {
                var keysMatchCounter = 0;
                var nodeIndex = -1;
                var parentIndex = -1;
                var cellValue;

                if (enableTreeView) {
                    outputData = $filter('filter')(data, function (row, index) {
                        if (row.$$treeLevel == 0) {
                            nodeIndex++;
                            parentIndex = index;
                            row.$$enableTreeView = false;
                        }
                        else {
                            try {
                                data[parentIndex].$$enableTreeView = true;
                            }
                            catch (e) { }
                        }

                        row.$$nodeIndex = nodeIndex;
                        row.$$index = index;
                        row.$$parentIndex = parentIndex;
                        row.$$isExpanded = data[parentIndex].$$isExpanded || !showTreeView;
                        row.$$isSelectable = angular.isUndefined(row.$$isSelectable) ? true : row.$$isSelectable;
                        keysMatchCounter = 0;

                        for (var j = 0; j < filters.length; j++) {
                            cellValue = (filters[j].colDef.enableTranslation && $translate.instant(getObjectValue(row, filters[j].filterKey) + '')) || getObjectValue(row, filters[j].filterKey) + '';

                            if ((cellValue.toLowerCase()).indexOf((filters[j].filterText + '').toLowerCase()) > -1 ||
                            (angular.isFunction(filters[j].condition) && filters[j].condition(filters[j].filterText, row, filters[j].colDef))) {
                                keysMatchCounter++;
                            }
                        }

                        return (row.$$treeLevel == 0 && keysMatchCounter == filters.length) ||
                            (row.$$treeLevel != 0 && row.$$isExpanded && keysMatchCounter == filters.length) ||
                            (row.$$treeLevel == 0 && isParentRowToBeDisplayed(data, index, filters));
                    });
                }
                else {
                    outputData = $filter('filter')(data, function (row, index) {
                        row.$$index = index;
                        row.$$isSelectable = angular.isUndefined(row.$$isSelectable) ? true : row.$$isSelectable;
                        keysMatchCounter = 0;

                        for (var j = 0; j < filters.length; j++) {
                            cellValue = (filters[j].colDef.enableTranslation && $translate.instant(getObjectValue(row, filters[j].filterKey) + '')) || getObjectValue(row, filters[j].filterKey) + '';

                            if ((cellValue.toLowerCase()).indexOf((filters[j].filterText + '').toLowerCase()) > -1 ||
                            (angular.isFunction(filters[j].condition) && filters[j].condition(filters[j].filterText, row, filters[j].colDef))) {
                                keysMatchCounter++;
                            }
                        }

                        return keysMatchCounter == filters.length;
                    });
                }
            }

            if (sortState) {
                if (enableTreeView) {
                    //	reorder tree data
                    var arrParentNodes = $filter('filter')(outputData, function (row) {
                        return row.$$treeLevel == 0;
                    });
                    if (sortState.order > -1) {
                        if (angular.isFunction(sortState.condition)) {
                            arrParentNodes = sortState.condition(arrParentNodes, sortState.column, sortState.order == 0 ? false : true);
                        }
                        else {
                            arrParentNodes = sortSmartTableData(arrParentNodes, sortState.column, sortState.order == 0 ? false : true, $translate);
                        }
                    }
                    var arrOrderedData = [];
                    angular.forEach(arrParentNodes, function (row) {
                        arrOrderedData = arrOrderedData.concat([row]).concat(getChildrenNodes(outputData, row.$$nodeIndex));
                    });
                    outputData = arrOrderedData;
                }
                else {
                    if (sortState.order > -1) {
                        if (angular.isFunction(sortState.condition)) {
                            outputData = sortState.condition(outputData, sortState.column, sortState.order == 0 ? false : true);
                        }
                        else {
                            outputData = sortSmartTableData(outputData, sortState.column, sortState.order == 0 ? false : true, $translate);
                        }
                    }
                }
            }

            if (!useExternalPagination) {
                //	Update total number of pages
                smartTableUtils.broadcast('dataChange', { totalRecords: outputData.length, smartTableId: smartTableId });

                outputData = outputData.slice(offset, limit);

                //	Update currently displayed records count
                smartTableUtils.broadcast('pageIndexChanged', { currentPageDataLength: outputData.length, smartTableId: smartTableId });
            }

            return outputData;
        }
    }]);


    app.directive('smartTable', ['$filter', '$timeout', '$templateCache', 'smartTableUtils', function ($filter, $timeout, $templateCache, smartTableUtils) {
        return {
            restrict: 'EA',
            replace: true,
            transclude: true,
            scope: {
                smartTable: '=?'
            },
            link: function (scope, element, attrs) {
                var areEventListenersAdded = false, arrSelectedRowsIndexes = [], smartTableState;
                var pageIndex = 0;
                var recordsFetchedCount = 0;
                var totalPages;
                var apis;
				var isStatePageIndexSet = false;

                var sortOrder = 1;  //  1 = descending, 0 = ascending, -1 = reset
                scope.filters = [];
                scope.enableRowSelection = false;
                scope.enableTreeView = false;
                scope.showTreeView = false;
                scope.arrRowsPerPageOptions = [10, 20, 30, 40, 50];
                scope.rowsPerPage = "10";
                scope.useExternalPagination = false;
                scope.smartTableId = 'smart-table-' + (new Date().getTime());

                scope.listeners = {};

                var limit = parseInt(scope.rowsPerPage);

                var addEventListeners = function (smartTable) {
                    apis = {
                        core: {
                            getActiveColumns: function () {
                                return scope.smartTableConfig.columnDefs;
                            },
                            getColDefs: function () {
                                return scope.smartTableConfig.columnDefs;
                            },
                            notifyColumnChange: function () {
                                init('columnChange');
                            },
                            notifyRowDataChange: function (rowIndex) {
                                smartTableUtils.broadcast('rowDataChange', { rowIndex: rowIndex, smartTableId: scope.smartTableId });
                            },
                            notifyDataChange: function (isToBeRefreshed) {
                                if (isToBeRefreshed) {
                                    init('refresh');
                                }
                                else {
                                    smartTableUtils.broadcast('dataChange', { smartTableId: scope.smartTableId, updateCell: true });
                                }
                            },
                            refresh: function () {
                                scope.enableRowSelection = scope.smartTableConfig.enableRowSelection ? true : false;
                                scope.enableTreeView = scope.smartTableConfig.enableTreeView ? true : false;
                                scope.showTreeView = scope.smartTableConfig.showTreeView ? true : false;
                                scope.useExternalPagination = scope.smartTableConfig.useExternalPagination ? true : false;
                                init('refresh');
                                angular.isFunction(smartTable.onRefresh) && smartTable.onRefresh(apis);
                            },
                            update: function () {
                                init('dataChange');
                            },
                            stopEdit: function () {
                                if (window.lastActiveCellScope) {
                                    window.lastActiveCellScope.stopEdit();
                                    window.lastActiveCellScope = undefined;
                                }
                            },
                            pagination: {
                                on: {
                                    nextButtonClick: function (scopeRef, onNextButtonClick) {
                                        scope.listeners['nextButtonClick'] = onNextButtonClick;
                                    },
                                    previousButtonClick: function (scopeRef, onPreviousButtonClick) {
                                        scope.listeners['previousButtonClick'] = onPreviousButtonClick;
                                    },
                                    sort: function (scopeRef, onSort) {
                                        scope.listeners['sort'] = onSort;
                                    },
                                    filter: function (scopeRef, onFilter) {
                                        scope.listeners['filter'] = onFilter;
                                    }
                                },
                                setDataLength: function (totalItemsCount) {
                                    scope.displayedRecords = totalItemsCount;
                                },
                                setData: function (items) {
                                    scope.smartTableConfig.data = items;
                                    scope.currentPageDataLength = items.length;
                                },
                                setOffset: function (offset) {
                                    scope.offset = offset;
                                },
                                setLimit: function (limit) {
                                    scope.limit = limit;
                                },
                                getOffset: function () {
                                    return scope.offset;
                                },
                                getRowsPerPage: function () {
                                    return scope.rowsPerPage;
                                }
                            },
                            on: {
                                columnRefresh: function (scopeRef, onColumnRefresh) {
                                    scope.listeners['columnRefresh'] = onColumnRefresh;
                                }
                            }
                        },
                        cell: {
                            on: {
                                click: function (scopeRef, onCellClick) {
                                    scope.listeners['cellClick'] = onCellClick;
                                },
                                change: function (scopeRef, onCellChange) {
                                    scope.listeners['cellChange'] = onCellChange;
                                },
                                optionsChange: function (scopeRef, onOptionsChange) {
                                    scope.listeners['optionsChange'] = onOptionsChange;
                                },
                                optionSelect: function (scopeRef, onOptionSelect) {
                                    scope.listeners['optionSelect'] = onOptionSelect;
                                }
                            }
                        },
                        cellNav: {
                            scrollToFocus: function (rowIndex, colField) {
                                var columnIndex, toBeFocused = true;

                                for (var i = 0; i < scope.colDefs.length; i++) {
                                    if (scope.colDefs[i].field == colField) {
                                        columnIndex = i;
                                        break;
                                    }
                                }

                                if (scope.enableTreeView && scope.showTreeView && !scope.smartTableConfig.data[scope.smartTableConfig.data[rowIndex].$$parentIndex].$$isExpanded) {
                                    scope.pendingFocus = {
                                        rowIndex: rowIndex,
                                        columnIndex: columnIndex
                                    };
                                    scope.smartTableConfig.data[scope.smartTableConfig.data[rowIndex].$$parentIndex].$$isExpanded = true;
                                    toBeFocused = false;
                                }

                                //  Load next page
                                if (rowIndex > (scope.limit > scope.displayedRecords ? scope.displayedRecords : scope.limit) - 1) {
                                    scope.pendingFocus = {
                                        rowIndex: rowIndex,
                                        columnIndex: columnIndex
                                    };
                                    scope.updatePagination(true, false);
                                }
                                    //  Load previous page
                                else if (rowIndex < scope.offset) {
                                    scope.pendingFocus = {
                                        rowIndex: rowIndex,
                                        columnIndex: columnIndex
                                    };
                                    scope.updatePagination(false, false);
                                }
                                else if (toBeFocused) {
                                    scope.pendingFocus = undefined;
                                    $('#' + scope.smartTableId + '-smart-table-cell-' + ((scope.pinnedColumns.length + scope.unpinnedColumns.length) * (rowIndex - scope.offset) + columnIndex)).focus();
                                    //smartTableUtils.broadcast('focusCell', { rowIndex: rowIndex - scope.offset, colField: colField, smartTableId: scope.smartTableId });
                                }

                                document.getSelection().removeAllRanges();
                            }
                        },
                        edit: {
                            on: {
                                beginCellEdit: function (scopeRef, onBeginCellEdit) {
                                    scope.listeners['beginCellEdit'] = onBeginCellEdit;
                                },
                                endCellEdit: function (scopeRef, onEndCellEdit) {
                                    scope.listeners['endCellEdit'] = onEndCellEdit;
                                },
                                afterCellEdit: function (scopeRef, onAfterCellEdit) {
                                    scope.listeners['afterCellEdit'] = onAfterCellEdit;
                                }
                            }
                        },
                        saveState: {
                            save: function () {
                                var columnsState = [];
                                var tmpColDefs = getReOrderedColumnDefsForState(scope.smartTableConfig.columnDefs);

                                for (var i = 0; i < tmpColDefs.length; i++) {
                                    columnsState.push({
                                        displayKey: tmpColDefs[i].displayKey,
                                        displayName: tmpColDefs[i].displayName,
                                        field: tmpColDefs[i].field,
                                        width: tmpColDefs[i].width,
                                        visible: tmpColDefs[i].visible
                                    });
                                }

                                return {
                                    columns: JSON.stringify(columnsState),
                                    filters: scope.filters,
                                    sort: scope.sortState,
                                    enableRowSelection: scope.enableRowSelection,
                                    enableTreeView: scope.enableTreeView,
                                    showTreeView: scope.showTreeView,
                                    pagination: {
                                        pageIndex: pageIndex,
                                        limit: limit,
                                        paginationCurrentPage: 1,
                                        paginationPageSize: 10
                                    },
                                    timestamp: new Date(),
                                    documentURL: window.location.href,
                                    isSmartTable: true
                                };
                            },
                            restore: function (scopeRef, state) {
                                //	restore table state
                                if (state.isSmartTable) {
                                    scope.enableRowSelection = state.enableRowSelection ? true : false;
                                    scope.enableTreeView = state.enableTreeView ? true : false;
                                    scope.showTreeView = state.showTreeView ? true : false;

                                    if (state.filters && !scope.useExternalPagination && scope.smartTable.showFilters != undefined) {
                                        scope.filters = state.filters;
                                    }
                                    if (angular.isDefined(state.columns)) {
                                        scope.smartTableConfig.columnDefs = getReOrderedColumnDefs(state.columns);
                                    }
                                    if (!scope.useExternalPagination) {
                                        if (state.pagination) {
                                            pageIndex = state.pagination.limit > 10 ? 0 : (state.pagination.pageIndex > (Math.ceil(scope.smartTableConfig.data.length / 10) - 1) ? 0 : state.pagination.pageIndex);
                                            limit = 10; // state.pagination.limit;
                                            scope.offset = pageIndex * limit;
                                            scope.limit = (pageIndex * limit) + limit;
                                            scope.rowsPerPage = "10";
                                            isStatePageIndexSet = true;
                                        }
                                        if (state.sort) {
                                            scope.sortState = state.sort;
                                            sortOrder = state.sort.order;
                                        }
                                    }
                                    refreshColumns();
                                    angular.isFunction(smartTable.onRefresh) && smartTable.onRefresh(apis);
                                }
                                else {
                                    scope.enableRowSelection = scope.smartTableConfig.enableRowSelection ? true : false;
                                    scope.enableTreeView = scope.smartTableConfig.enableTreeView ? true : false;
                                    scope.showTreeView = scope.smartTableConfig.showTreeView ? true : false;
                                    init('refresh');
                                }
                            }
                        },
                        selection: {
                            clearSelectedRows: function () {
                                if(scope.useExternalPagination && angular.isFunction(scope.listeners.clearSelectedRows)){
                                    return scope.listeners.clearSelectedRows(scope);
                                 }
                                for (var i = 0; i < scope.smartTableConfig.data.length; i++) {
                                    scope.smartTableConfig.data[i].$$isSelected = false;
                                }
                                arrSelectedRowsIndexes = [];
                                scope.isAllRowSelected = false;
                            },
                            getSelectedRows: function () {
                                if(scope.useExternalPagination && angular.isFunction(scope.listeners.getSelectedrows)){
                                    return scope.listeners.getSelectedrows(scope);
                                 }
                                var tmpSelectedRows = [], tmpRow, arrDeletedIndexes = [];
                                for (var i = 0; i < arrSelectedRowsIndexes.length; i++) {
                                    tmpRow = angular.copy(scope.smartTableConfig.data[arrSelectedRowsIndexes[i]]);
                                    if (tmpRow) {
                                        tmpRow.$$isSelected = false;
                                        tmpSelectedRows.push({ entity: tmpRow, index: arrSelectedRowsIndexes[i] });
                                    }
                                    else {
                                        arrDeletedIndexes.push(i);
                                    }
                                }
                                for (var i = arrDeletedIndexes.length - 1; i >= 0; i--) {
                                    arrSelectedRowsIndexes.splice(arrDeletedIndexes[i], 1);
                                }
                                return tmpSelectedRows;
                            },
                            on: {
                                rowSelectionChanged: function (scopeRef, onRowSelectedChanged) {
                                    scope.listeners['rowSelectionChanged'] = onRowSelectedChanged;
                                },
                                rowSelect: function(scopeRef, onRowSelect){
                                    scope.listeners['onRowSelect'] = onRowSelect;
                                },
                                getSelectedRows: function($scope, getSelectedrows){
                                    scope.listeners['getSelectedrows'] = getSelectedrows;
                                },
                                clearSelectedRows: function($scope, clearSelectedRows){
                                    scope.listeners['clearSelectedRows'] = clearSelectedRows;
                                }
                            }
                        },
                        update:{
                            setAllRowSelected: function (isAllRowSelected) {
                                scope.isAllRowSelected = isAllRowSelected;
                            }
                        },
                        options: scope.smartTableConfig
                    };
                    angular.isFunction(smartTable.onRegister) && smartTable.onRegister(apis);
                };


                var onSmartTableConfigChange = scope.$watch('smartTable', function (newConfig) {
                    if (!newConfig) {
                        return;
                    }

                    scope.smartTableConfig = newConfig;
                    scope.enableRowSelection = scope.smartTableConfig.enableRowSelection ? true : false;
                    scope.enableTreeView = scope.smartTableConfig.enableTreeView ? true : false;
                    scope.showTreeView = scope.smartTableConfig.showTreeView ? true : false;
                    scope.useExternalPagination = scope.smartTableConfig.useExternalPagination ? true : false;
                    scope.enableRowsPerPage = scope.smartTableConfig.enableRowsPerPage ? true : false;

                    scope.smartTableConfig.columnDefs = newConfig.columnDefs ? newConfig.columnDefs : [];
                    scope.smartTableConfig.data = newConfig.data ? newConfig.data : [];

                    init('refresh');

                    if (!areEventListenersAdded) {
                        addEventListeners(scope.smartTable);
                        areEventListenersAdded = true;
                    }
                });


                var getColumnDef = function (srcConfig, colField) {
                    for (var i = 0; i < srcConfig.length; i++) {
                        if (srcConfig[i].field == colField) {
                            return srcConfig[i];
                        }
                    }
                    return undefined;
                };


                var getColumFilterText = function (colField) {
                    for (var i = 0; i < scope.filters.length; i++) {
                        if (scope.filters[i].filterKey == colField) {
                            return scope.filters[i].filterText;
                        }
                    }
                    return undefined;
                };


                var getReOrderedColumnDefs = function (colDefs) {
                    colDefs = typeof colDefs == 'string' ? JSON.parse(colDefs) : colDefs;
                    for (var i = 0; i < scope.smartTableConfig.columnDefs.length; i++) {
                        if (angular.isUndefined(getColumnDef(colDefs, scope.smartTableConfig.columnDefs[i].field))) {
                            return scope.smartTableConfig.columnDefs;
                        }
                    }
                    var reOrderedColumns = [];
                    var colDef;
                    for (var i = 0; i < colDefs.length; i++) {
                        colDef = getColumnDef(scope.smartTableConfig.columnDefs, colDefs[i].field);
                        if (angular.isUndefined(colDef)) {
                            return scope.smartTableConfig.columnDefs;
                        }
                        reOrderedColumns.push(angular.extend(colDef, {
                            width: colDefs[i].width,
                            visible: angular.isUndefined(colDefs[i].visible) ? colDef.visible : colDefs[i].visible,
                            filterText: getColumFilterText(colDefs[i].field)
                        }));
                    }
                    return reOrderedColumns;
                };


                var getReOrderedColumnDefsForState = function (colDefs) {
                    var pinnedColumns = [];
                    var unpinnedColumns = [];

                    for (var i = 0; i < colDefs.length; i++) {
                        if (colDefs[i].pinnedLeft) {
                            pinnedColumns.push(colDefs[i]);
                        }
                        else {
                            unpinnedColumns.push(colDefs[i]);
                        }
                    }

                    return pinnedColumns.concat(unpinnedColumns);
                };

                function setFilterText() {
                    for (var i = 0; i < scope.smartTableConfig.columnDefs.length; i++) {
                        var field = scope.smartTableConfig.columnDefs[i].field;
                        var filterDef = '';
                        for (var j = 0; j < scope.filters.length; j++) {
                            if (scope.filters[j] && scope.filters[j].filterKey == field) {
                                filterDef = scope.filters[j];
                                break;
                            }
                        }
                        scope.smartTableConfig.columnDefs[i].filterText = filterDef ? filterDef.filterText : "";
                    }
                };

                var refreshColumns = function () {
                    var pinnedColumns = [];
                    var unpinnedColumns = [];
                    var pinnedContainerWidth = 0;

                    setFilterText();

                    var colDefs = angular.copy(scope.smartTableConfig.columnDefs);
                    var tmpColDefs = [];
                    var leftPos = (scope.enableRowSelection ? 40 : 0) + (scope.enableTreeView && scope.showTreeView ? 40 : 0);

                    for (var i = 0; i < colDefs.length; i++) {
                        if (colDefs[i].visible == false) {
                            continue;
                        }

                        if (colDefs[i].pinnedLeft) {
                            pinnedColumns.push(colDefs[i]);
                        }
                        else {
                            colDefs[i].pinnedLeft = false;
                            unpinnedColumns.push(colDefs[i]);
                        }
                    }

                    colDefs = pinnedColumns.concat(unpinnedColumns);
                    pinnedColumns = [];
                    unpinnedColumns = [];

                    for (var i = 0; i < colDefs.length; i++) {
                        if (colDefs[i].visible == false) {
                            continue;
                        }

                        colDefs[i].left = leftPos;

                        leftPos = leftPos + colDefs[i].width;

                        if (colDefs[i].pinnedLeft) {
                            pinnedContainerWidth = pinnedContainerWidth + (colDefs[i].visible ? (colDefs[i].width ? colDefs[i].width : '100') : 0);
                            pinnedColumns.push(colDefs[i]);
                        }
                        else {
                            unpinnedColumns.push(colDefs[i]);
                        }
                    }

                    tmpColDefs = pinnedColumns.concat(unpinnedColumns);

                    scope.colDefs = angular.copy(tmpColDefs);

                    $(element.find('.smart-table-unpinned-container')).css(window.isRTL ? 'margin-right': 'margin-left', pinnedContainerWidth + (scope.enableRowSelection ? 40 : 0) + (scope.enableTreeView && scope.showTreeView ? 40 : 0));

                    scope.pinnedColumns = pinnedColumns;
                    scope.unpinnedColumns = unpinnedColumns;

                    scope.updateSmartTableColumnResizer = true;
                    scope.updateSmartTableColumnSorter = true;
                };


                var init = function (eventType) {
                    switch (eventType) {
                        case 'refresh':
                            pageIndex = 0;
                            scope.rowsPerPage = "10";
                            limit = parseInt(scope.rowsPerPage); // 10;
                            recordsFetchedCount = 0;

                            sortOrder = 1;

                            for (var i = 0; i < scope.smartTableConfig.columnDefs.length; i++) {
                                scope.smartTableConfig.columnDefs[i].filterText = "";
                            }

                            scope.filters = [];
                            scope.sortState = undefined;

                            scope.isRowSelectionEnabled = true;
                            scope.isAllRowSelected = false;

                            refreshColumns();

                            scope.updatePagination(false, true);
                            break;

                        case 'columnChange':
                        case 'dataChange':
                            refreshColumns();
                            break;
                    }
                };


                scope.updatePagination = function (isNextButtonClicked, isRefresh) {
                    if (scope.useExternalPagination) {
                        if (isNextButtonClicked) {
                            angular.isFunction(scope.listeners.nextButtonClick) && scope.listeners.nextButtonClick({isRefresh:isRefresh, smartTableScope: scope});
                        }
                        else {
                            angular.isFunction(scope.listeners.previousButtonClick) && scope.listeners.previousButtonClick({isRefresh:isRefresh, smartTableScope: scope});
                        }
                        return;
                    }

                    if (isRefresh) {
                        scope.offset = 0;
                        scope.limit = parseInt(scope.rowsPerPage); // 10
                        pageIndex = 0;
                    }
                    else {
                        if (isNextButtonClicked && pageIndex < totalPages) {
                            pageIndex++;
                        }
                        else if (!isNextButtonClicked && pageIndex > 0) {
                            pageIndex--;
                        }
                        scope.offset = pageIndex * limit;
                        scope.limit = (pageIndex * limit) + limit;
                    }
                };


                scope.onRowsPerPageOptionChange = function (rowsPerPage) {
                    limit = parseInt(rowsPerPage);
                    scope.updatePagination(false, true);
                };


                scope.filterData = function (column) {
                    for (var i = 0; i < scope.filters.length; i++) {
                        if (scope.filters[i].filterKey == column.field) {
                            if (column.filterText.trim() == '') {
                                scope.filters.splice(i, 1);
                            }
                            else {
                                scope.filters[i].filterText = column.filterText;
                            }
                            scope.updatePagination(false, true);
                            return;
                        }
                    }
                    scope.filters.push({
                        filterKey: column.field,
                        filterText: column.filterText,
                        colDef: column,
                        condition: column.hasOwnProperty('filter') && column.filter.condition
                    });
                    scope.updatePagination(false, true);
                };


                scope.sortData = function (column) {
                    smartTableUtils.debounce.add(function () {
                        //	If new column needs to be sorted, then reset sort flag
                        if (scope.sortState && scope.sortState.column.field != column.field || sortOrder < -1) {
                            sortOrder = 1;
                        }
                        refreshColumns();
                        scope.updatePagination(false, true);
                        scope.sortState = {
                            column: column,
                            order: sortOrder,
                            condition: column.sortCondition
                        };
                        sortOrder--;
                    }, 250);
                };


                scope.selectRow = function (row, rowIndex, shouldSelectedAllRows) {
                    if(scope.useExternalPagination && angular.isFunction(scope.listeners.onRowSelect)){
                        scope.listeners.onRowSelect(row, rowIndex, shouldSelectedAllRows, scope);
                        return;
                    }
                    if (shouldSelectedAllRows) {
                        scope.isAllRowSelected = !scope.isAllRowSelected;
                        if (scope.isAllRowSelected) {
                            arrSelectedRowsIndexes = [];
                        }
                        for (var i = 0; i < scope.smartTableConfig.data.length; i++) {
                            scope.smartTableConfig.data[i].$$isSelected = scope.smartTableConfig.data[i].$$isSelectable && scope.isAllRowSelected;
                            if (scope.isAllRowSelected && scope.smartTableConfig.data[i].$$isSelected) {
                                arrSelectedRowsIndexes.push(i);
                            }
                        }
                        if (!scope.isAllRowSelected) {
                            arrSelectedRowsIndexes = [];
                        }
                    }
                    else {
                        row.$$isSelected = row.$$isSelectable && !row.$$isSelected;
                        if (row.$$isSelected) {
                            arrSelectedRowsIndexes.push(rowIndex);
                        }
                        else {
                            if (arrSelectedRowsIndexes.indexOf(rowIndex) > -1) {
                                arrSelectedRowsIndexes.splice(arrSelectedRowsIndexes.indexOf(rowIndex), 1);
                            }
                        }
                        scope.isAllRowSelected = arrSelectedRowsIndexes.length == scope.smartTableConfig.data.length;
                    }

                    if (/*rowIndex > -1 &&*/ angular.isFunction(scope.listeners.rowSelectionChanged)) {
                        scope.listeners.rowSelectionChanged({
                            row: {
                                entity: row,
                                index: rowIndex,
                                isSelected: scope.isAllRowSelected || (row && row.$$isSelected)
                            }
                        });
                    }
                };


                scope.expandRow = function (row, rowIndex, shouldExpandAllRows) {
                    if (shouldExpandAllRows) {
                        for (var i = 0; i < scope.smartTableConfig.data.length; i++) {
                            if (scope.smartTableConfig.data[i].$$treeLevel == 0) {
                                scope.smartTableConfig.data[i].$$isExpanded = !scope.isAllRowExpanded
                            }
                        }
                        scope.isAllRowExpanded = !scope.isAllRowExpanded;
                        scope.updatePagination(false, true);
                    }
                    else {
                        if (row.$$treeLevel > 0) {
                            return;
                        }
                        row.$$isExpanded = !row.$$isExpanded;
                        scope.isAllRowExpanded = false;
                    }
                };


                scope.onColumnSort = function (e) {
                    var activeColDefs = angular.copy(scope.colDefs);
                    var startIndex, endIndex, toBeSorted;

                    var startCol = activeColDefs[e.startIndex];
                    var endCol = activeColDefs[e.endIndex];

                    if (startCol.pinnedLeft != endCol.pinnedLeft || startCol.field == endCol.field) {
                        return;
                    }

                    scope.$apply(function () {
                        for (var i = 0; i < scope.smartTableConfig.columnDefs.length; i++) {
                            if (scope.smartTableConfig.columnDefs[i].field == startCol.field) {
                                startIndex = i;
                                if (angular.isDefined(endIndex)) {
                                    break;
                                }
                            }

                            if (scope.smartTableConfig.columnDefs[i].field == endCol.field) {
                                endIndex = i;
                                if (angular.isDefined(startIndex)) {
                                    break;
                                }
                            }
                        }

                        var tmpColDefs = angular.copy(scope.smartTableConfig.columnDefs);
                        var item = tmpColDefs.splice(startIndex, 1);
                        tmpColDefs.splice(endIndex, 0, item[0]);
                        scope.smartTableConfig.columnDefs = angular.copy(tmpColDefs);
                        tmpColDefs = null;

                        init('columnChange');
                        angular.isFunction(scope.listeners.columnRefresh) && scope.listeners.columnRefresh(scope.colDefs);
                    });
                };


                scope.onColumnResize = function (e) {
                    var activeColDefs = angular.copy(scope.colDefs);
                    var colToBeResized;

                    for (var i = 0; i < activeColDefs.length; i++) {
                        if (e.columnIndex == i) {
                            colToBeResized = activeColDefs[i];
                            break;
                        }
                    }

                    for (var i = 0; i < scope.smartTableConfig.columnDefs.length; i++) {
                        if (scope.smartTableConfig.columnDefs[i].field == colToBeResized.field) {
                            scope.smartTableConfig.columnDefs[i].width = e.width;
                            break;
                        }
                    }

                    init('columnChange');
                    angular.isFunction(scope.listeners.columnRefresh) && scope.listeners.columnRefresh(scope.colDefs);
                };


                var watchers;

                scope.onSmartTableRenderingStart = function () {
                    watchers = scope.$$watchers;
                    scope.$$watchers = [];
                    // window.startTime = performance.now();
                    // console.log('rendering start');
                };

                scope.onSmartTableRenderingDone = function () {
                    if (watchers) {
                        scope.$$watchers = watchers;
                    }
                    // discard our copy of the watchers
                    watchers = void 0;
                    // console.log('rendering done in => ' + ((performance.now() - window.startTime) / 1000) + ' seconds');
                };

                var onDataChange = smartTableUtils.on('dataChange', function (e) {
                    if (angular.isDefined(e.totalRecords) && e.smartTableId == scope.smartTableId) {
                        totalPages = Math.ceil(e.totalRecords / limit) - 1;
                        scope.displayedRecords = e.totalRecords;
                    }
                });

                var onPageIndexChanged = smartTableUtils.on('pageIndexChanged', function (e) {
                    if (e.smartTableId == scope.smartTableId) {
                        scope.currentPageDataLength = e.currentPageDataLength;
                    }
                });

                var onSmartTableCurrentPageDataLength = scope.$watch('currentPageDataLength', function (newLength) {
                    if (newLength == 0 && pageIndex > 0 && !isStatePageIndexSet) {
                        scope.updatePagination(false, false);
                    }
                    isStatePageIndexSet = false;
                });

                scope.$on('$destroy', function () {
                    onSmartTableConfigChange();
                    onPageIndexChanged();
                    onSmartTableCurrentPageDataLength();
                });
            },
            templateUrl: 'shared/directives/smartTable/smartTableTemplate.html'
        };
    }]);

    app.service('smartTableUtils', ['$timeout', function ($timeout) {
        var _this = this;

        /*
         *  Alternative of broadcast event
         */
        var arrEvents = [];
        var eventCounter = 0;


        /*
         *  Deregister an event or events
         */
        this.removeEventListener = function (event) {
            for (var i = 0; i < arrEvents.length; i++) {
                if (arrEvents[i].eventName == event.eventName && arrEvents[i].eventId == event.eventId) {
                    arrEvents[i].callback = null;
                    arrEvents.splice(i, 1);
                    break;
                }
            }
        };


        /*
         *  Register a listener
         */
        this.on = function (eventName, callback) {
            eventCounter++;
            arrEvents.push({
                eventName: eventName,
                callback: callback,
                eventId: 'smart-broadcast-event-' + eventCounter
            });
            var objEvent = {
                eventName: eventName,
                eventId: 'smart-broadcast-event-' + eventCounter
            };
            return function () {
                _this.removeEventListener(objEvent);
            };
        };


        /*
         *  Fire an event
         */
        this.broadcast = function (eventName, data) {
            for (var i = 0; i < arrEvents.length; i++) {
                if (eventName == arrEvents[i].eventName) {
                    angular.isFunction(arrEvents[i].callback) && arrEvents[i].callback(data);
                }
            }
        };


        /*
	     *	Debouncer logic
		 */
        var functionTimeout, isAngularTimeout;

        this.debounce = {
            add: function (callback, duration, isDigestCycleToBeTriggered) {
                if (functionTimeout) {
                    if (angular.isDefined(isDigestCycleToBeTriggered) && isDigestCycleToBeTriggered == false) {
                        clearTimeout(functionTimeout);
                    }
                    else {
                        $timeout.cancel(functionTimeout);
                    }
                }
                functionTimeout = angular.isDefined(isDigestCycleToBeTriggered) && isDigestCycleToBeTriggered == false ? setTimeout(function () {
                    angular.isFunction(callback) && callback();
                }, duration ? duration : 1000) : $timeout(function () {
                    angular.isFunction(callback) && callback();
                }, duration ? duration : 1000);
                isAngularTimeout = !angular.isDefined(isDigestCycleToBeTriggered) && isDigestCycleToBeTriggered == false;
            },
            cancel: function () {
                if (isAngularTimeout) {
                    $timeout.cancel(functionTimeout);
                }
                else {
                    clearTimeout(functionTimeout);
                }
                functionTimeout = null;
            }
        };
    }]);

    app.directive('smartTableCellStyle', ['$compile', '$timeout',
	function () {
	    return {
	        restrict: 'A',
	        link: function (scope, element, attrs) {
	            //	to watch the rendering changes e.g. sort or filter
	            var onColumnConfigChange = scope.$watch('column', function (n) {
	                init();
	            });

	            var init = function () {
	                element.removeClass('smart-table-pinned-column smart-table-unpinned-column');
	                if (scope.column.pinnedLeft) {
	                    element.addClass('smart-table-pinned-column');
	                    element.css(window.isRTL ? 'right' : 'left', scope.column.left);
	                    element.css('width', scope.column.width);
	                }
	                else {
	                    element.addClass('smart-table-unpinned-column');
	                }
	            };

	            scope.$on('$destroy', function () {
	                onColumnConfigChange();
	            });
	        }
	    };
	}]);

    app.directive('smartTableHeaderCellTextContainer', ['$compile', '$timeout',
	function () {
	    return {
	        restrict: 'C',
	        link: function (scope, element, attrs) {
	            //	to watch the rendering changes e.g. sort or filter
	            var onColumnConfigChange = scope.$watch('column', function (n) {
	                init();
	            });

	            var init = function () {
	                element.css('width', scope.column.width - (scope.column.pinnedLeft ? 12 : 0));
	            };

	            scope.$on('$destroy', function () {
	                onColumnConfigChange();
	            });
	        }
	    };
	}]);

    app.directive('smartTableColumnResizer', [function () {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var isMouseDown, canBeResized, resizer, leftPosLimit = 0, columnIndex, maxWidth, width, newWidth;

                var onMouseMove = function (e) {
                    if (isMouseDown) {
                        if (e.clientX > leftPosLimit && (angular.isUndefined(maxWidth) || (angular.isDefined(maxWidth) && e.clientX - leftPosLimit < maxWidth))) {
                            resizer.css({
                                left: e.clientX
                            });
                        }
                        document.getSelection().removeAllRanges();
                    }
                    else {
                        if (e.offsetX > (($(this).outerWidth(true) - 2) - 5) && e.offsetX < (($(this).outerWidth(true) - 2))) {
                            $(this).css('cursor', 'col-resize');
                        }
                        else {
                            $(this).css('cursor', 'default');
                        }
                    }
                };

                var onMouseUp = function (e) {
                    if (isMouseDown) {
                        resizer.off('mousemove', onMouseMove);
                        resizer.off('mouseup', onMouseUp);
                        resizer.remove();
                        canBeResized = false;
                        isMouseDown = false;
                        newWidth = (angular.isDefined(maxWidth) && e.clientX - leftPosLimit > maxWidth) ? maxWidth : e.clientX - leftPosLimit;

                        if (Math.abs(newWidth - width) > 5) {
                            scope.$apply(function () {
                                scope.onColumnResize({
                                    columnIndex: columnIndex,
                                    width: newWidth < 20 ? 20 : newWidth
                                });
                            });
                        }
                    }
                };

                var onMouseDown = function (e) {
                    if (e.offsetX >= (($(this).outerWidth(true) - 2) - 5) && e.offsetX < (($(this).outerWidth(true) - 2))) {
                        $(this).css('cursor', 'col-resize');
                        leftPosLimit = $(this).offset().left;
                        resizer = $(document.createElement('div'));
                        columnIndex = parseInt($(this).attr('column-index'));
                        maxWidth = scope.colDefs[columnIndex].maxWidth;
                        width = scope.colDefs[columnIndex].width;

                        resizer.css({
                            position: 'absolute',
                            left: $(this).offset().left + $(this).outerWidth(true),
                            top: $(this).offset().top,
                            width: '1px',
                            height: $(this).closest('table').outerHeight(true),
                            'z-index': 1000,
                            border: 'dotted'
                        });

                        resizer.on('mousemove', onMouseMove);
                        resizer.on('mouseup', onMouseUp);

                        $(document.body).append(resizer);

                        isMouseDown = true;
                    }
                    else {
                        $(this).css('cursor', 'default');
                    }
                };

                var bindEvents = function () {
                    setTimeout(function () {
                        element.find('th').not('.smart-table-icon-holder').off('mousedown', onMouseDown);
                        element.find('th').not('.smart-table-icon-holder').off('mouseup', onMouseUp);
                        element.find('th').not('.smart-table-icon-holder').off('mousemove', onMouseMove);

                        element.find('th').not('.smart-table-icon-holder').on('mousedown', onMouseDown);
                        element.find('th').not('.smart-table-icon-holder').on('mouseup', onMouseUp);
                        element.find('th').not('.smart-table-icon-holder').on('mousemove', onMouseMove);
                    }, 250);
                };

                scope.$watch('updateSmartTableColumnResizer', function (newValue) {
                    if (newValue) {
                        bindEvents();
                        scope.updateSmartTableColumnResizer = false;
                    }
                });
            }
        };
    }]);

    app.directive('smartTableColumnSorter', [function () {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var isMouseDown, startX, offsetX, isPinnedColumn, clone, mouseDownTimeout;

                var onMouseMove = function (e) {
                    if (isMouseDown) {
                        $(clone).css({
                            left: e.clientX - offsetX
                        });
                        document.getSelection().removeAllRanges();
                    }
                };

                var onMouseUp = function (e) {
                    $(clone).off('mousemove', onMouseMove);
                    $(clone).off('mouseup', onMouseUp);
                    $(clone).off('mouseleave', onMouseUp);
                    $(clone).remove();

                    if (isMouseDown && e.type == 'mouseup') {
                        var startIndex, endIndex;

                        element.find('th').not('.smart-table-icon-holder').each(function (index, th) {
                            if (angular.isUndefined(startIndex) && startX > $(th).offset().left && startX < $(th).offset().left + $(th).outerWidth(true)) {
                                startIndex = index;
                            }
                            else if (angular.isUndefined(endIndex) && e.clientX > $(th).offset().left && e.clientX < $(th).offset().left + $(th).outerWidth(true)) {
                                endIndex = index;
                            }
                        });

                        if (angular.isDefined(startIndex) && angular.isDefined(endIndex)) {
                            scope.onColumnSort({
                                startIndex: startIndex,
                                endIndex: endIndex,
                                isPinnedColumn: isPinnedColumn
                            });
                        }
                    }

                    isMouseDown = false;

                    if (mouseDownTimeout) {
                        clearTimeout(mouseDownTimeout);
                        mouseDownTimeout = undefined;
                    }
                };

                var onMouseDown = function (e) {
                    if ($(e.target).closest('.smart-table-search-container').length > 0 || e.offsetX >= $(this).outerWidth(true) - 20) {
                        return;
                    }

                    var $this = this;

                    mouseDownTimeout = setTimeout(function () {
                        startX = e.clientX;
                        offsetX = e.offsetX;
                        isMouseDown = true;

                        isPinnedColumn = $(e.target).closest('.smart-table-pinned-column').length > 0;
                        clone = $($this).clone();

                        $(clone).on('mousemove', onMouseMove);
                        $(clone).on('mouseup', onMouseUp);
                        $(clone).on('mouseleave', onMouseUp);

                        $(clone).css({
                            position: 'absolute',
                            left: $($this).offset().left,
                            top: $($this).offset().top,
                            width: $($this).outerWidth(true),
                            height: $($this).outerHeight(true),
                            'z-index': 1000,
                            border: 'dotted'
                        });

                        $(document.body).append(clone);

                        mouseDownTimeout = undefined;
                    }, 500);
                };

                var bindEvents = function () {
                    setTimeout(function () {
                        element.find('th').not('.smart-table-icon-holder').off('mousedown', onMouseDown);
                        element.find('th').not('.smart-table-icon-holder').off('mouseup', onMouseUp);
                        element.find('th').not('.smart-table-icon-holder').off('mousemove', onMouseMove);

                        element.find('th').not('.smart-table-icon-holder').on('mousedown', onMouseDown);
                        element.find('th').not('.smart-table-icon-holder').on('mousemove', onMouseMove);
                        element.find('th').not('.smart-table-icon-holder').on('mouseup', onMouseUp);
                    }, 250);
                };

                scope.$watch('updateSmartTableColumnSorter', function (newValue) {
                    if (newValue) {
                        bindEvents();
                        scope.updateSmartTableColumnSorter = false;
                    }
                });
            }
        };
    }]);

    app.directive('smartTableCell', ['$rootScope', '$compile', '$timeout', 'smartTableUtils', '$filter', '$translate', 'APPCONSTANTS', 'httpService',
	function ($rootScope, $compile, $timeout, smartTableUtils, $filter, $translate, APPCONSTANTS, httpService) {
	    return {
	        restrict: 'EA',
	        replace: true,
	        link: function (scope, element, attrs) {
	            var tabIndex, oldCellValue, oldCellClass, tmpCellValue, tmpInputValue, tmpValueForAutoSuggest;
	            var isInEditMode = false, selectedOption, selectedDate;

	            var templateContainer, cellClassElement = $(element.closest('.smart-table-row-cell'));
	            var hasStopEditCalled = false, isLineNumberAssigned = false, isInputFieldFocused = false, isRenderingToBeSkipped = false, isFocusToBeSkipped = false;

	            var appScope = scope.$parent.$parent.$parent;
	            var smartTableScope = scope.$parent.$parent;

	            //	to watch the rendering changes e.g. sort or filter, col def change
	            var onCellDataAndColDefChange = scope.$watchGroup(['value', 'column'], function (n) {
	                tabIndex = (scope.pinnedColumns.length + scope.unpinnedColumns.length) * scope.$parent.$index + scope.$index;
	                element.attr('id', smartTableScope.smartTableId + '-smart-table-cell-' + tabIndex);
	                element.attr('tabindex', tabIndex);
	                oldCellClass = undefined;
	                init(false, true);
	                if (angular.isDefined(smartTableScope.pendingFocus) && (smartTableScope.pendingFocus.rowIndex - smartTableScope.offset) == scope.rowIndex && smartTableScope.pendingFocus.columnIndex == scope.columnIndex) {
	                    element.trigger('focus');
	                    scope.pendingFocus = undefined;
	                }
	            });

	            var init = function (isRowDataUpdated, toBeTranslated) {
	                scope.row = {
	                    entity: scope.value
	                };

	                if (angular.isDefined(scope.column) && scope.column.uiType == 'editable' && scope.column.attributes.type == 'date' && isRegionalSettingEnabled) {
	                    scope.column.attributes.format = moment.localeData().longDateFormat('L').toLowerCase().replace(/m/g, 'M');
	                }

	                scope.enableCellEdit = angular.copy(scope.column.enableCellEdit);

	                cellClassElement.removeClass('smart-table-row-cell-invalid smart-table-row-cell-disabled smart-table-row-cell-canceled smart-table-row-cell-warning');

	                $(element.closest('.smart-table-row-cell-text')).css({
	                    border: '',
	                    width: scope.column.width + (scope.column.pinnedLeft ? -2 : 10)
	                });

	                if (!isRowDataUpdated) {
	                    //	rendering start callback
	                    if (!smartTableScope.hasSmartTableRenderingStarted) {
	                        scope.onSmartTableRenderingStart();
	                        smartTableScope.hasSmartTableRenderingStarted = true;
	                    }

	                    scope.pinned = attrs.pinned == 'true';

	                    scope.rowIndex = scope.$parent.$index;
	                    scope.columnIndex = scope.$index;

	                    if (scope.column.autoIncrement && !smartTableScope.useExternalPagination) {
	                        if (angular.isDefined(scope.row.entity.$$nodeIndex)) {
	                            updateCell(scope.row.entity, scope.column.field, scope.row.entity.$$nodeIndex + 1);
	                        }
	                        else {
	                            updateCell(scope.row.entity, scope.column.field, scope.row.entity.$$index + 1);
	                        }
	                    }
	                }

	                if (angular.isDefined(scope.column.attributes) && scope.column.attributes.type == "autocomplete" &&
                    angular.isDefined(scope.column.attributes.displayformat) && angular.isDefined(scope.column.field)) {
	                    tmpValueForAutoSuggest = getObjectValueForAutoSuggest(scope.row.entity, scope.column.field);
	                    if (angular.isObject(tmpValueForAutoSuggest)) {
	                        //scope.COL_FIELD = getDisplayData(getObjectValue(scope.row.entity, scope.column.field.split('.')[0]), scope.column.attributes.displayformat);
	                        scope.COL_FIELD = getDisplayData(tmpValueForAutoSuggest, scope.column.attributes.displayformat);
	                    }
	                    else {
	                        scope.COL_FIELD = getObjectValue(scope.row.entity, scope.column.field);
	                    }
	                }
	                else {
	                    scope.COL_FIELD = getObjectValue(scope.row.entity, scope.column.field);
	                }

	                if (angular.isFunction(scope.column.cellClass) /*&& oldCellValue != scope.COL_FIELD*/) {
	                    var tmpClass = scope.column.cellClass({}, { entity: scope.row.entity, index: scope.rowIndex }, { colDef: scope.column, index: scope.columnIndex, value: getObjectValue(scope.row.entity, scope.column.field) });
	                    if (angular.isObject(tmpClass)) {
	                        if (cellClassElement.find('.smart-table-row-cell-info-icon').length == 0) {
	                            var iconTemplate = '';
	                            switch (tmpClass.type) {
	                                case 'smart-table-row-cell-info':
	                                    iconTemplate += '<svg><use xlink:href="#icon_Info"></use></svg>';
	                                    break;
	                                default:
	                                    iconTemplate += '<svg><use xlink:href="#icon_Info"></use></svg>';
	                                    break;
	                            }
	                            cellClassElement.find('.smart-table-cell-text').append('<i class="icon small blue-text smart-table-row-cell-info-icon" style="float: right; line-height: 23px !important;" title="' + tmpClass.message + '">' + iconTemplate + '</i>');
	                        }
	                        cellClassElement.addClass(tmpClass.class);
	                    }
	                    else {
	                        cellClassElement.addClass(tmpClass);
	                    }
	                    oldCellClass = tmpClass;
	                }

	                if (angular.isFunction(scope.column.cellEditableCondition)) {
	                    scope.enableCellEdit = scope.column.cellEditableCondition({ row: scope.row, index: scope.rowIndex, col: { colDef: scope.column, index: scope.columnIndex }, grid: { rows: smartTableScope.smartTableConfig.data }, cellElement: element });
	                }

	                updateCellTemplate(true, toBeTranslated);

	                if (!isRowDataUpdated) {
	                    //	rendering done callback
	                    if (scope.$parent.$last && scope.$last) {
	                        scope.onSmartTableRenderingDone();
	                        smartTableScope.hasSmartTableRenderingStarted = false;
	                    }
	                }
	            };

	            // init();


	            //  Update date
	            var updateDate = function (tmpDate) {
	                if (selectedDate == '/Date(' + ((tmpDate.unix() * 1000) + 43200000) + '+0000)/') {
	                    return;
	                }
	                selectedDate = '/Date(' + ((tmpDate.unix() * 1000) + 43200000) + '+0000)/';
	                element.find('input').val($filter('smartDateFormat')(selectedDate, scope.column.attributes.format));
	                if (scope.column.isRegUpdateCol) {
	                    //	cell change listener
	                    angular.isFunction(smartTableScope.listeners.cellChange) && smartTableScope.listeners.cellChange({ entity: scope.row.entity, index: scope.rowIndex }, { colDef: scope.column, index: scope.columnIndex }, { value: selectedDate });
	                }
	            };


	            //  Pop-up listeners
	            var onPopupOpened, onPopupClosed;

	            var addPopupListeners = function () {
	                var oldCellModel, newCellModel;

	                onPopupOpened = $rootScope.$on("popupOpened", function () {
	                    oldCellModel = getObjectValue(scope.row.entity, scope.column.field);
	                });

	                onPopupClosed = $rootScope.$on("popupClosed", function () {
	                    if (angular.isDefined(scope.column.debounce) && scope.column.debounce > 0) {
	                        setTimeout(function () {
	                            newCellModel = getObjectValue(scope.row.entity, scope.column.field);
	                            updateCellValueForPopup(oldCellModel, newCellModel);
	                        }, scope.column.debounce);
	                    }
	                    else {
	                        newCellModel = getObjectValue(scope.row.entity, scope.column.field);
	                        updateCellValueForPopup(oldCellModel, newCellModel);
	                    }

	                    element.trigger('focus');
	                });
	            };


	            var updateCellValueForPopup = function (oldCellModel, newCellModel) {
	                if (!angular.equals(oldCellModel, newCellModel)) {
	                    scope.COL_FIELD = newCellModel;
	                    updateCellTemplate(true, true);
	                    angular.isFunction(smartTableScope.listeners.cellChange) && smartTableScope.listeners.cellChange({ entity: scope.row.entity, index: scope.rowIndex }, { colDef: scope.column, index: scope.columnIndex });
	                }
	            };


	            var removePopupListeners = function () {
	                angular.isFunction(onPopupOpened) && onPopupOpened();
	                angular.isFunction(onPopupClosed) && onPopupClosed();
	            };

	            function triggerTaxesPopup() {
	                element.trigger("blur");
	                smartTableUtils.debounce.add(function () {
	                    window.isPopupOpenedByUIGridCompatibleElement = true;
	                    angular.isFunction(smartTableScope.listeners.cellClick) && smartTableScope.listeners.cellClick({ entity: scope.row.entity, index: scope.rowIndex }, { colDef: scope.column, index: scope.columnIndex });
	                }, 100);
	            }
	            function triggerAdhocPopup() {

	                smartTableUtils.debounce.add(function () {
	                    window.isPopupOpenedByUIGridCompatibleElement = true;
	                    angular.isFunction(smartTableScope.listeners.cellClick) && smartTableScope.listeners.cellClick({ entity: scope.row.entity, index: scope.rowIndex }, { colDef: scope.column, index: scope.columnIndex });
	                }, 100);
	                event.stopPropagation();
	                event.preventDefault();
	            }
	            function triggerSupplierCardPopup() {

	                smartTableUtils.debounce.add(function () {
	                    window.isPopupOpenedByUIGridCompatibleElement = true;
	                    angular.isFunction(smartTableScope.listeners.cellClick) && smartTableScope.listeners.cellClick({ entity: scope.row.entity, index: scope.rowIndex }, { colDef: scope.column, index: scope.columnIndex });
	                }, 100);
	                event.stopPropagation();
	                event.preventDefault();
	            }
	            var updateCellTemplate = function (toBeFiltered, toBeTranslated) {
	                if (angular.isFunction(scope.column.cellTemplate)) {
	                    tmpCellValue = scope.column.cellTemplate({ entity: scope.row.entity, index: scope.rowIndex }, { colDef: scope.column, index: scope.columnIndex });
	                    if (scope.column.uiType == 'popup' && angular.isNumber(tmpCellValue)) {
	                        if (angular.isDefined(scope.column.attributes.minmaxprecisionfilter)) {
	                            tmpCellValue = $filter('minPrecisionHandler')(tmpCellValue, scope.column.attributes.minmaxprecisionfilter.split(':')[0], scope.column.attributes.minmaxprecisionfilter.split(':')[1], false);
	                        }
	                        else {
	                            tmpCellValue = $filter('minPrecisionHandler')(tmpCellValue);
	                        }
	                    }
	                    element.find('.smart-table-cell-template').html((scope.column.uiType == 'popup' ? '<a' + (scope.column.enableCellEdit && scope.enableCellEdit ? '' : ' class="disabled" ') + '>' : '<span>') + tmpCellValue + (scope.column.uiType == 'popup' ? '</a>' : '</span>'));
	                    element.parent().attr('title', tmpCellValue);
	                    return;
	                }

	                if (scope.column.uiType == 'editable') {
	                    switch (scope.column.attributes.type) {
	                        case 'number':
	                            if (toBeFiltered && angular.isDefined(scope.column.attributes.minmaxprecisionfilter)) {
	                                scope.COL_FIELD = $filter('minPrecisionHandler')(scope.COL_FIELD, scope.column.attributes.minmaxprecisionfilter.split(':')[0], scope.column.attributes.minmaxprecisionfilter.split(':')[1], false);
	                            }
	                            break;

	                        case 'date':
	                            if (toBeFiltered) {
	                                scope.COL_FIELD = scope.COL_FIELD == '' || scope.COL_FIELD == undefined || scope.COL_FIELD == null ? '' : $filter('smartDateFormat')(scope.COL_FIELD, scope.column.attributes.format);
	                            }
	                            break;

	                        default:
	                            if (toBeTranslated && scope.column.enableTranslation) {
	                                scope.COL_FIELD = $translate.instant(scope.COL_FIELD);
	                            }
	                            if (toBeFiltered && angular.isDefined(scope.column.attributes.maxlength) && angular.isDefined(scope.COL_FIELD)) {
	                                scope.COL_FIELD = scope.COL_FIELD.substr(0, scope.column.attributes.maxlength);
	                            }
	                            break;
	                    }
	                    tmpCellValue = (scope.COL_FIELD == undefined || scope.COL_FIELD == null ? '' : scope.COL_FIELD);
	                    element.find('.smart-table-cell-template').html('<span>' + tmpCellValue + '</span>');
	                    if (scope.column.uiType == "editable" && scope.column.adhocpopup && scope.column.adhocpopup === "adhocpopup") {
	                        var icon = $('<i style="float: right" class="icon small blue-text smart-table-row-cell-info-icon" style="float: right; line-height: 23px !important;" title="' + $translate.instant("P2P_Common_AddAdhocLocation") + '"><svg><use xlink:href="#icon_Location"></use></svg></i>')
	                        icon.mousedown(function () {
	                            triggerAdhocPopup();
	                        })
	                        element.find('.smart-table-cell-template').append(icon);
	                    }
	                    else if (scope.column.uiType == "editable" && scope.column.supplierCardPopup && scope.column.supplierCardPopup === "supplierCardPopup") {
	                        var icon = $('<i style="float: right" class="icon small blue-text smart-table-row-cell-info-icon" style="float: right; line-height: 23px !important;" title="' + $translate.instant("P2P_Req_SupplierName") + '"><svg><use xlink:href="#icon_ContactCard"></use></svg></i>')
	                        icon.mousedown(function () {
	                            triggerSupplierCardPopup();
	                        })
	                        element.find('.smart-table-cell-template').append(icon);
	                    }
	                    if (scope.row.entity.RequisitionSource != undefined && scope.row.entity.RequisitionSource == 3 && scope.column.uiType == "editable" && scope.column.Changereq && scope.column.Changereq === "Changereq") {
	                        if (scope.row.entity.IsAddedFromRequistion != undefined) {
	                            if (scope.row.entity.IsAddedFromRequistion == true) {
	                            }
	                            else {
	                                var icon = $('<i  style="float: right" class="icon small red-text smart-table-row-cell-info-icon" style="float: right; line-height: 23px !important;" title=""><svg><use xlink:href="#icon_AddToDefault "></use></svg></i>')
	                                element.find('.smart-table-cell-template').append(icon);
	                            }
	                        }
	                    }
	                }
	                else if (scope.column.uiType == 'popup') {
	                    tmpCellValue = (scope.COL_FIELD === '' || scope.COL_FIELD == undefined || scope.COL_FIELD == null) ? (scope.column.placeHolder ? scope.column.placeHolder : $translate.instant('P2P_Common_Add')) : scope.COL_FIELD;
	                    if (angular.isNumber(tmpCellValue)) {
	                        if (angular.isDefined(scope.column.attributes.minmaxprecisionfilter)) {
	                            tmpCellValue = $filter('minPrecisionHandler')(tmpCellValue, scope.column.attributes.minmaxprecisionfilter.split(':')[0], scope.column.attributes.minmaxprecisionfilter.split(':')[1], false);
	                        }
	                        else {
	                            tmpCellValue = $filter('minPrecisionHandler')(tmpCellValue);
	                        }
	                    }
	                    element.find('.smart-table-cell-template').html('<a' + (scope.column.enableCellEdit && scope.enableCellEdit ? '' : ' class="disabled" ') + '>' + tmpCellValue + '</a>');
	                }
	                else if (scope.column.uiType == 'dropdown') {
	                    tmpCellValue = toBeTranslated && scope.column.enableTranslation ? $translate.instant(scope.COL_FIELD) : scope.COL_FIELD;
	                    element.find('.smart-table-cell-template').html('<span>' + tmpCellValue + '</span>');
	                }
	                else if (scope.column.uiType == 'taxesPopup') {
	                    tmpCellValue = scope.row.entity[scope.column.field];

	                    if (angular.isNumber(tmpCellValue)) {
	                        if (angular.isDefined(scope.column.attributes.minmaxprecisionfilter)) {
	                            tmpCellValue = $filter('minPrecisionHandler')(tmpCellValue, scope.column.attributes.minmaxprecisionfilter.split(':')[0], scope.column.attributes.minmaxprecisionfilter.split(':')[1], false);
	                        }
	                        else {
	                            tmpCellValue = $filter('minPrecisionHandler')(tmpCellValue);
	                        }
	                    }

	                    element.find('.smart-table-cell-template').html('<a' + (scope.column.enableCellEdit && scope.enableCellEdit ? '' : ' class="disabled" ') + '>' + tmpCellValue + '</a>');
	                    if (scope.row.entity.isTaxExempt) {
	                        var taxExempt = $('<a>' + $translate.instant("P2P_Common_Exempt") + '</a>');
	                        taxExempt.mousedown(function () {
	                            triggerTaxesPopup();
	                        })
	                        element.find('.smart-table-cell-template').html(taxExempt);
	                    }
	                    var icon = $('<i style="float: right" class="icon iconSmall tooltipped" smart-tooltip position="bottom" delay="50" message="ADD"><svg><use xlink:href="#icon_CirclePlus"></use></svg></i>')
	                    icon.mousedown(function () {
	                        triggerTaxesPopup();
	                    })
	                    element.find('.smart-table-cell-template').append(icon);
	                    element.parent().attr('title', tmpCellValue);
	                }
	                else {
	                    if (toBeFiltered && scope.column.attributes && scope.column.attributes.type == 'number' && angular.isDefined(scope.column.attributes.minmaxprecisionfilter)) {
	                        scope.COL_FIELD = $filter('minPrecisionHandler')(scope.COL_FIELD, scope.column.attributes.minmaxprecisionfilter.split(':')[0], scope.column.attributes.minmaxprecisionfilter.split(':')[1], false);
	                    }
	                    tmpCellValue = toBeTranslated && scope.column.enableTranslation ? $translate.instant(scope.COL_FIELD) : (scope.COL_FIELD == undefined || scope.COL_FIELD == null ? '' : scope.COL_FIELD);
	                    element.find('.smart-table-cell-template').html('<span>' + tmpCellValue + '</span>');
	                }
	                element.parent().attr('title', tmpCellValue);
	            };


	            var getEditableTemplate = function () {
	                var template = '<div>';
	                switch (scope.column.uiType) {
	                    case 'editable':
	                        switch (scope.column.attributes.type) {
	                            case 'number':
	                                tmpInputValue = parseFloat(getObjectValue(scope.row.entity, scope.column.field));

	                                if (!isRegionalSettingEnabled && angular.isDefined(scope.column.attributes.minmaxprecisionfilter)) {
	                                    tmpInputValue = convertNumberToFixed(tmpInputValue, scope.column.attributes.minmaxprecisionfilter.split(':')[0], scope.column.attributes.minmaxprecisionfilter.split(':')[1])
	                                }

	                                template += '<input type="number" autocomplete="off" value="' + (tmpInputValue == 0 ? '' : tmpInputValue) + '">';
	                                break;

	                            case 'date':
	                                template += '<input type="text" autocomplete="off" value="' + (scope.COL_FIELD == undefined || scope.COL_FIELD == null ? '' : scope.COL_FIELD) + '" placeholder="' + (scope.column.attributes.format ? (scope.column.attributes.format).toUpperCase() : 'MM/DD/YYYY') + '">';
	                                break;

	                            default:
	                                template += '<input type="text" autocomplete="off" value="' + (scope.COL_FIELD == undefined || scope.COL_FIELD == null ? '' : scope.COL_FIELD) + '"' + (angular.isDefined(scope.column.attributes.maxlength) ? ' maxlength=' + scope.column.attributes.maxlength : '') + '>';
	                                break;
	                        }
	                        break;

	                    case 'dropdown':
	                    case 'select':
	                        template += '<select style="display: block !important;">';
	                        for (var i = 0; i < scope.column.attributes.options.length; i++) {
	                            template += '<option ' + ($translate.instant(scope.column.attributes.options[i][scope.column.attributes.dataKey] + '') == $translate.instant(scope.COL_FIELD + '') ? 'selected' : '') + ' value="' + $translate.instant(scope.column.attributes.options[i][scope.column.attributes.idKey] + '') + '">' + $translate.instant(scope.column.attributes.options[i][scope.column.attributes.dataKey] + '') + '</option>';
	                        }
	                        template += '</select>';
	                        break;

	                        //case 'popup':
	                        //    template += '<div><a>' + ((scope.COL_FIELD === '' || scope.COL_FIELD == undefined || scope.COL_FIELD == null) ? (scope.column.placeHolder ? scope.column.placeHolder : 'ADD') : scope.COL_FIELD) + '</a></div>';
	                        //    break;
	                }
	                return template + '</div>'
	            };


	            var onElementKeyDown = function (e) {
	                window.lastKeyPressed = e.keyCode;
	                switch (e.keyCode) {
	                    //	space key
	                    case 32:
	                        if (scope.column.uiType == 'editable' && element.find('input').length > 0) {
	                            if (element.find('input:focus').length > 0) {
	                                isInputFieldFocused = true;
	                            }
	                            if (scope.column.attributes.type == 'date') {
	                                element.find('input').focus();
	                                e.stopPropagation();
	                                return false;
	                            }
	                            else {
	                                if (!isInputFieldFocused) {
	                                    isInputFieldFocused = true;

	                                    //if (element.find('input:focus').length == 0) {
	                                    tmpInputValue = element.find('input').val();
	                                    element.find('input').focus().val('').val(tmpInputValue);
	                                    //if (element.find('input').val().trim().length == 0) {
	                                    e.stopPropagation();
	                                    return false;
	                                    //}
	                                    //}
	                                }
	                            }
	                        }
	                        else if (scope.column.uiType == 'dropdown' && element.find('select').length > 0) {
	                            element.find('select').focus();
	                        }
 	                        else if (scope.column.uiType == 'popup' && scope.column.enableCellEdit && angular.isFunction(scope.column.cellEditableCondition) && scope.column.cellEditableCondition({ row: scope.row, col: { colDef: scope.column }, grid: { rows: smartTableScope.smartTableConfig.data }, cellElement: element }) && scope.column.isRegClickCol) {
	                            smartTableUtils.debounce.add(function () {
	                                window.isPopupOpenedByUIGridCompatibleElement = true;
	                                //	cell click listener
	                                angular.isFunction(smartTableScope.listeners.cellClick) && smartTableScope.listeners.cellClick({ entity: scope.row.entity, index: scope.rowIndex }, { colDef: scope.column, index: scope.columnIndex });
	                            }, 100);
	                            e.stopPropagation();
	                            return false;
	                        }
	                        else {
	                            e.stopPropagation();
	                            return false;
	                        }
	                        break;
	                        //	arrow keys
	                    case 37:
	                        if (!isInputFieldFocused) {
	                            if (element.find('input:focus').length > 0) {
	                                isInputFieldFocused = true;
	                                return;
	                            }

	                            if (scope.rowIndex == 0 && scope.columnIndex == 0) { }
	                            else {
	                                $('#' + smartTableScope.smartTableId + '-smart-table-cell-' + (parseInt(tabIndex) - 1)).focus();
	                                scope.stopEdit();
	                            }
	                            e.stopPropagation();
	                            return false;
	                        }
	                        break;
	                    case 39:
	                    case 9:
	                        if (e.keyCode == 39) {
	                            if (!isInputFieldFocused) {
	                                if (element.find('input:focus').length > 0) {
	                                    isInputFieldFocused = true;
	                                    return;
	                                }

	                                if (scope.$parent.$last && scope.$last) {
	                                    $('#' + smartTableScope.smartTableId + '-smart-table-cell-0').focus();
	                                }
	                                else {
	                                    $('#' + smartTableScope.smartTableId + '-smart-table-cell-' + (parseInt(tabIndex) + 1)).focus();
	                                }
	                                scope.stopEdit();
	                                e.stopPropagation();
	                                return false;
	                            }
	                        }
	                        else {
	                            if (e.shiftKey) {
	                                if (scope.rowIndex == 0 && scope.columnIndex == 0) {
	                                }
	                                else {
	                                    $('#' + smartTableScope.smartTableId + '-smart-table-cell-' + (parseInt(tabIndex) - 1)).focus();
	                                    scope.stopEdit();
	                                }
	                            }
	                            else {
	                                $('#' + smartTableScope.smartTableId + '-smart-table-cell-' + (parseInt(tabIndex) + 1)).focus();
	                                scope.stopEdit();
	                            }
	                            e.stopPropagation();
	                            return false;
	                        }
	                        break;
	                    case 38:
	                        // if(!$(e.target).is('select')) {
	                        if (scope.rowIndex > 0) {
	                            var cellIndexFocus = parseInt(tabIndex) - (smartTableScope.pinnedColumns.length + smartTableScope.unpinnedColumns.length);
	                            $('#' + smartTableScope.smartTableId + '-smart-table-cell-' + cellIndexFocus).focus();
	                            scope.stopEdit();
	                        }
	                        e.stopPropagation();
	                        return false;
	                        // }
	                        break;
	                    case 40:
	                    case 13:
	                        // if(!$(e.target).is('select')) {
	                        if (scope.rowIndex < smartTableScope.currentPageDataLength - 1) {
	                            var cellIndexFocus = parseInt(tabIndex) + (smartTableScope.pinnedColumns.length + smartTableScope.unpinnedColumns.length);
	                            $('#' + smartTableScope.smartTableId + '-smart-table-cell-' + cellIndexFocus).focus();
	                            scope.stopEdit();
	                        }
	                        e.stopPropagation();
	                        return false;
	                        // }
	                        break;
	                        //  escape key
	                    case 27:
	                        if ((scope.column.uiType == 'editable' || scope.column.uiType == 'dropdown') && (scope.column.attributes.type != 'autocomplete' || (scope.column.attributes.type == 'autocomplete' &&
                            scope.column.isFreeText && !selectedOption))) {
	                            isInputFieldFocused = false;

	                            if (scope.column.attributes.type == 'number') {
	                                tmpInputValue = parseFloat(oldCellValue);
	                                if (!isRegionalSettingEnabled && angular.isDefined(scope.column.attributes.minmaxprecisionfilter)) {
	                                    tmpInputValue = convertNumberToFixed(tmpInputValue, scope.column.attributes.minmaxprecisionfilter.split(':')[0], scope.column.attributes.minmaxprecisionfilter.split(':')[1]);
	                                }
	                                element.find('input').val(tmpInputValue == 0 ? '' : tmpInputValue).blur();
	                                if (isRegionalSettingEnabled) {
	                                    try {
	                                        element.find('input').autoNumeric('get');
	                                    }
	                                    catch (e) { }
	                                }
	                                updateCell(scope.row.entity, scope.column.field, oldCellValue);
	                            }
	                            else if (scope.column.attributes.type == 'date') {
	                                element.find('input').val($filter('smartDateFormat')(oldCellValue, scope.column.attributes.format)).blur();
	                                updateCell(scope.row.entity, scope.column.field, oldCellValue);
	                                selectedDate = undefined;
	                            }
	                            else {
	                                if (scope.column.uiType == 'dropdown') {
	                                    var tmpPreviousSelectedDropdownObj;
	                                    for (var i = 0; i < scope.column.attributes.options.length; i++) {
	                                        if (oldCellValue == scope.column.attributes.options[i][scope.column.attributes.dataKey]) {
	                                            tmpPreviousSelectedDropdownObj = scope.column.attributes.options[i];
	                                            updateCell(scope.row.entity, scope.column.field, scope.column.attributes.options[i]);
	                                            break;
	                                        }
	                                    }
	                                    element.find('select').val(tmpPreviousSelectedDropdownObj[scope.column.attributes.idKey]).blur();
	                                }
	                                else {
	                                    element.find('input').val(oldCellValue).blur();
	                                    updateCell(scope.row.entity, scope.column.field, oldCellValue);
	                                }
	                            }

	                            isRenderingToBeSkipped = true;
	                            isFocusToBeSkipped = true;
	                            element.focus();

	                            if (scope.column.attributes.type == 'number' && scope.column.isRegUpdateCol) {
	                                smartTableUtils.debounce.add(function () {
	                                    //	cell change listener
	                                    angular.isFunction(smartTableScope.listeners.cellChange) && smartTableScope.listeners.cellChange({ entity: scope.row.entity, index: scope.rowIndex }, { colDef: scope.column, index: scope.columnIndex });
	                                    smartTableUtils.broadcast('rowDataChange', { rowIndex: scope.rowIndex, smartTableId: smartTableScope.smartTableId });
	                                }, 250, false);
	                            }
	                            else if (scope.column.attributes.type == 'date') {
	                                if (scope.column.isRegUpdateCol) {
	                                    //	cell change listener
	                                    angular.isFunction(smartTableScope.listeners.cellChange) && smartTableScope.listeners.cellChange({ entity: scope.row.entity, index: scope.rowIndex }, { colDef: scope.column, index: scope.columnIndex }, { value: selectedDate });
	                                }
	                            }
	                            else if (scope.column.uiType == 'dropdown') {
	                                // Options change listener
	                                angular.isFunction(smartTableScope.listeners.optionSelect) && smartTableScope.listeners.optionSelect({ entity: scope.row.entity, index: scope.rowIndex }, { colDef: scope.column, index: scope.columnIndex }, { value: tmpPreviousSelectedDropdownObj });
	                            }
	                        }
	                        break;
	                    default:
	                        //  disable focus on function and filter keys
	                        if ((e.keyCode >= 112 && e.keyCode <= 123) || [16, 20, 255, 17, 91, 18, 33, 34, 144, 45, 19, 145, 93, 173, 174, 175].indexOf(e.keyCode) > -1) {
	                            e.preventDefault();
	                            return false;
	                        }
	                        if ((scope.column.uiType == 'editable' || scope.column.uiType == 'taxesPopup') && element.find('input').length > 0) {
	                            //  HOME and END keys
	                            if (!isInputFieldFocused && [35, 36].indexOf(e.keyCode) > -1) {
	                                e.preventDefault();
	                                return false;
	                            }
	                            if (!isInputFieldFocused) {
	                                isInputFieldFocused = true;

	                                if (element.find('input:focus').length == 0) {
	                                    //tmpInputValue = element.find('input').val();
	                                    //element.find('input').focus().val('').val(tmpInputValue);
	                                    element.find('input').focus().val('');

	                                    if (scope.column.attributes.type == 'number' && !isRegionalSettingEnabled && angular.isDefined(scope.column.attributes.minmaxprecisionfilter)) {
	                                        var arrDecimalSplits = element.find('input').val().split('.');

	                                        if (arrDecimalSplits.length > 1) {
	                                            if (arrDecimalSplits[arrDecimalSplits.length - 1].length >= scope.column.attributes.minmaxprecisionfilter.split(':')[1] && ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105))) {
	                                                e.preventDefault();
	                                                return false;
	                                            }
	                                        }
	                                        else if (scope.column.attributes.minmaxprecisionfilter.split(':')[0] == 0 && e.keyCode == 190) {
	                                            e.preventDefault();
	                                            return false;
	                                        }
	                                    }
	                                }
	                            }
	                        }
	                        else if (scope.column.uiType == 'dropdown' && element.find('select').length > 0) {
	                            element.find('select').focus();
	                        }
	                        if (e.keyCode == 8 && element.find('input').length == 0) {
	                            e.preventDefault();
	                            return false;
	                        }
	                        break;
	                }
	            };

	            scope.onElementKeyDown = onElementKeyDown;

	            element.on('keydown', onElementKeyDown);


	            scope.stopEdit = function (isWindowClickFired) {
	                isRenderingToBeSkipped = false;
	                isFocusToBeSkipped = false;

	                //  prevent stop edit 
	                if (isWindowClickFired && scope.column.uiType == 'popup') {
	                    return;
	                }

	                //	scroll container to left
	                if (scope.$last && window.lastKeyPressed != 37 && !window.isSmartTableCellClicked && (window.shiftKey && window.lastKeyPressed == 9)) {
	                    $(element.closest('.smart-table-unpinned-container')).scrollLeft(0);
	                }

	                if ((scope.column.uiType == 'popup' || scope.column.uiType == 'taxesPopup' || (scope.column.adhocpopup && scope.column.adhocpopup === "adhocpopup") || (scope.column.supplierCardPopup && scope.column.supplierCardPopup === "supplierCardPopup")) && scope.column.isRegClickCol) {
	                    removePopupListeners();
	                }

	                if (hasStopEditCalled) {
	                    return;
	                }

	                isInEditMode = false;
	                isInputFieldFocused = false;

	                //	If cell is editable
	                if (scope.column.enableCellEdit && (angular.isFunction(scope.column.cellEditableCondition) && scope.column.cellEditableCondition({ row: scope.row, col: { colDef: scope.column }, grid: { rows: smartTableScope.smartTableConfig.data }, cellElement: element }))) {
	                    switch (scope.column.uiType) {
	                        case 'editable':
	                            switch (scope.column.attributes.type) {
	                                case 'number':
	                                    if (isRegionalSettingEnabled) {
	                                        try {
	                                            scope.COL_FIELD = element.find('input').autoNumeric('get') * 1;
	                                        }
	                                        catch (error) {
	                                            console.log(error);
	                                            console.log("Error in number get. " + scope.column.field);
	                                        }
	                                    }
	                                    else {
	                                        scope.COL_FIELD = parseFloat($(element.find('input')).val());
	                                    }
	                                    scope.COL_FIELD = isNaN(scope.COL_FIELD) ? 0 : scope.COL_FIELD;
	                                    updateCell(scope.row.entity, scope.column.field, angular.copy(scope.COL_FIELD));
	                                    if (angular.isDefined(scope.column.attributes) && angular.isDefined(scope.column.attributes.minmaxprecisionfilter)) {
	                                        scope.COL_FIELD = $filter('minPrecisionHandler')(scope.COL_FIELD, scope.column.attributes.minmaxprecisionfilter.split(':')[0], scope.column.attributes.minmaxprecisionfilter.split(':')[1], false);
	                                    }
	                                    break;

	                                case 'autocomplete':
	                                    if (element.find('input').devbridgeAutocomplete()) {
	                                        element.find('input').devbridgeAutocomplete().dispose();
	                                    }
	                                    if (selectedOption) {
	                                        scope.COL_FIELD = angular.isDefined(scope.column.attributes.displayformat) ? getDisplayData(selectedOption, scope.column.attributes.displayformat) : $(element.find('input')).val();
	                                        updateCell(scope.row.entity, scope.column.field, selectedOption);
	                                        selectedOption = undefined;
	                                    }
	                                    else if (scope.column.isFreeText) {
	                                        scope.COL_FIELD = $(element.find('input')).val();
	                                        updateCell(scope.row.entity, scope.column.field, scope.COL_FIELD);
	                                    }
	                                    else {
	                                        scope.COL_FIELD = getObjectValue(scope.row.entity, scope.column.field);
	                                    }
	                                    break;

	                                case 'date':
	                                    if (element.find('input').daterangepicker()) {
	                                        element.find('input').daterangepicker().daterangepicker();
	                                    }
	                                    if (selectedDate == '') {
	                                        scope.COL_FIELD = '';
	                                        updateCell(scope.row.entity, scope.column.field, null);
	                                    }
	                                    else if (angular.isDefined(selectedDate) && selectedDate.indexOf('Date') > -1) {
	                                        scope.COL_FIELD = $filter('smartDateFormat')(selectedDate, scope.column.attributes.format);
	                                        updateCell(scope.row.entity, scope.column.field, selectedDate);
	                                    }
	                                    else {
	                                        scope.COL_FIELD = $filter('smartDateFormat')(getObjectValue(scope.row.entity, scope.column.field), scope.column.attributes.format);
	                                    }
	                                    selectedDate = undefined;
	                                    break;

	                                default:
	                                    scope.COL_FIELD = $(element.find('input')).val();
	                                    updateCell(scope.row.entity, scope.column.field, scope.COL_FIELD);
	                                    break;
	                            }
	                            break;

	                        case 'dropdown':
	                        case 'select':
	                            for (var i = 0; i < scope.column.attributes.options.length; i++) {
	                                if ($(element.find('select')).val() == scope.column.attributes.options[i][scope.column.attributes.idKey]) {
	                                    scope.COL_FIELD = scope.column.attributes.options[i][scope.column.attributes.dataKey];
	                                    updateCell(scope.row.entity, scope.column.field, scope.column.attributes.options[i]);
	                                    break;
	                                }
	                            }
	                            scope.COL_FIELD = scope.column.enableTranslation ? $translate.instant(scope.COL_FIELD) : scope.COL_FIELD;
	                            break;
	                        case 'taxesPopup':
	                            if (isRegionalSettingEnabled) {
	                                try {
	                                    if (element.find('input').length > 0) {
	                                        scope.COL_FIELD = element.find('input').autoNumeric('get') * 1;
	                                    }
	                                }
	                                catch (error) {
	                                    console.log(error);
	                                    console.log("Error in number get. " + scope.column.field);
	                                }
	                            }
	                            else {
	                                scope.COL_FIELD = parseFloat($(element.find('input')).val());
	                            }
	                            scope.COL_FIELD = isNaN(scope.COL_FIELD) ? 0 : scope.COL_FIELD;
	                            updateCell(scope.row.entity, scope.column.field, angular.copy(scope.COL_FIELD));
	                            if (angular.isDefined(scope.column.attributes) && angular.isDefined(scope.column.attributes.minmaxprecisionfilter)) {
	                                scope.COL_FIELD = $filter('minPrecisionHandler')(scope.COL_FIELD, scope.column.attributes.minmaxprecisionfilter.split(':')[0], scope.column.attributes.minmaxprecisionfilter.split(':')[1], false);
	                            }
	                            break;
	                    }
	                    updateCellTemplate();
	                }

	                $(element.closest('.smart-table-row-cell-text')).css('border', '');
	                templateContainer && templateContainer.empty();

	                if (scope.column.enableCellEdit && oldCellValue != scope.COL_FIELD) {
	                    if (oldCellValue != scope.COL_FIELD) {
	                        angular.isFunction(smartTableScope.listeners.afterCellEdit) && smartTableScope.listeners.afterCellEdit({ entity: scope.row.entity, index: scope.rowIndex }, { colDef: scope.column, index: scope.columnIndex }, {cellElement: element });

	                        smartTableUtils.broadcast('rowDataChange', { rowIndex: scope.rowIndex, smartTableId: smartTableScope.smartTableId });
	                    }

	                    //	end cell edit listener
	                    angular.isFunction(smartTableScope.listeners.endCellEdit) && smartTableScope.listeners.endCellEdit({ entity: scope.row.entity, index: scope.rowIndex }, { colDef: scope.column, index: scope.columnIndex });
	                }

	                if (scope.column.enableCellEdit && (scope.column.uiType == 'popup' || scope.column.uiType == 'taxesPopup')) {
	                    smartTableUtils.broadcast('rowDataChange', { rowIndex: scope.rowIndex, smartTableId: smartTableScope.smartTableId });
	                }

	                hasStopEditCalled = true;
	            };


	            var onFocus = function (e) {
	                if (isRenderingToBeSkipped) {
	                    if (element.find('input').length > 0 && !isFocusToBeSkipped) {
	                        element.find('input').focus();
	                    }
	                    return;
	                }

	                oldCellValue = scope.column.enableTranslation ? $translate.instant(scope.COL_FIELD) : (scope.column.uiType == 'editable' && (scope.column.attributes.type == 'date' || scope.column.attributes.type == 'number') ? getObjectValue(scope.row.entity, scope.column.field) : scope.COL_FIELD);

	                //  Prevent from scrolling to left
	                if (scope.$last) {
	                    window.lastKeyPressed = 37;
	                }

	                if (window.lastActiveCellScope) {
	                    window.lastActiveCellScope.stopEdit();
	                    window.lastActiveCellScope = undefined;
	                }

	                window.lastActiveCellScope = scope;

	                hasStopEditCalled = false;

	                //	scroll container to left
	                if (smartTableScope.pinnedColumns.length == scope.$index) {
	                    setTimeout(function () {
	                        $(element.closest('.smart-table-unpinned-container')).scrollLeft(0);
	                    }, 250);
	                }

	                if ((scope.column.uiType == 'popup' || scope.column.uiType == 'taxesPopup' || (scope.column.adhocpopup && scope.column.adhocpopup === "adhocpopup") || (scope.column.supplierCardPopup && scope.column.supplierCardPopup === "supplierCardPopup")) && scope.column.enableCellEdit && angular.isFunction(scope.column.cellEditableCondition) && scope.column.cellEditableCondition({ row: scope.row, col: { colDef: scope.column }, grid: { rows: smartTableScope.smartTableConfig.data }, cellElement: element }) && scope.column.isRegClickCol) {
	                    addPopupListeners();
	                }

	                window.isSmartTableCellClicked = false;

	                $(element.closest('.smart-table-row-cell-text')).css('border', '1px solid ' + (cellClassElement.hasClass('smart-table-row-cell-invalid') ? 'red' : '#159dfc'));
	                if (isInEditMode || !scope.column.enableCellEdit || (angular.isFunction(scope.column.cellEditableCondition) && !scope.column.cellEditableCondition({ row: scope.row, col: { colDef: scope.column }, grid: { rows: smartTableScope.smartTableConfig.data }, cellElement: element }))) {
	                    return;
	                }

	                //	Begin cell edit listener
	                angular.isFunction(smartTableScope.listeners.beginCellEdit) && smartTableScope.listeners.beginCellEdit({ entity: scope.row.entity, index: scope.rowIndex }, { colDef: scope.column, index: scope.columnIndex });

	                if (scope.column.uiType != 'popup') {
	                    $(element.find('.smart-table-cell-template')).html(getEditableTemplate());
	                    if (scope.column.uiType == "editable" && scope.column.adhocpopup && scope.column.adhocpopup === "adhocpopup") {
	                        var icon = $('<i style="float: right" class="icon small blue-text smart-table-row-cell-info-icon" style="float: right; line-height: 23px !important;" title="' + $translate.instant("P2P_Common_AddAdhocLocation") + '"><svg><use xlink:href="#icon_Location"></use></svg></i>');
	                        icon.mousedown(function () {
	                            triggerAdhocPopup();
	                        });
	                        var inputvalue = $(element.find('.smart-table-cell-template')).html(getEditableTemplate()).css("width", $(element.find('.smart-table-cell-template')).parent().width() - 40 + "px");
	                        $(element.find('.smart-table-cell-template')).append(inputvalue).append(icon);
	                    }
	                    else if (scope.column.uiType == "editable" && scope.column.supplierCardPopup && scope.column.supplierCardPopup === "supplierCardPopup") {
	                        var icon = $('<i style="float: right" class="icon small blue-text smart-table-row-cell-info-icon" style="float: right; line-height: 23px !important;" title="' + $translate.instant("P2P_Req_SupplierName") + '"><svg><use xlink:href="#icon_ContactCard"></use></svg></i>')
	                        icon.mousedown(function () {
	                            triggerSupplierCardPopup();
	                        })
	                        element.find('.smart-table-cell-template').append(icon);
	                    }
	                }

	                if (scope.column.uiType == 'taxesPopup') {
	                    var tmpInputValue = parseFloat(getObjectValue(scope.row.entity, scope.column.field));
	                    if (!isRegionalSettingEnabled && angular.isDefined(scope.column.attributes.minmaxprecisionfilter)) {
	                        tmpInputValue = convertNumberToFixed(tmpInputValue, scope.column.attributes.minmaxprecisionfilter.split(':')[0], scope.column.attributes.minmaxprecisionfilter.split(':')[1]);
	                    }
	                    var input = $('<input  type="number" autocomplete="off" value="' + (tmpInputValue == 0 ? '' : tmpInputValue) + '">');
	                    if (scope.row.entity.isTaxExempt) {
	                        input = $('<a>' + $translate.instant("P2P_Common_Exempt") + '</a>')
	                        input.mousedown(function () {
	                            triggerTaxesPopup();

	                        });
	                    }
	                    var icon = $('<i style="float: right" class="icon iconSmall tooltipped"><svg><use xlink:href="#icon_CirclePlus"></use></svg></i>');
	                    icon.mousedown(function () {
	                        triggerTaxesPopup();
	                    });
	                    input.css("width", $(element.find('.smart-table-cell-template')).parent().width() - 40 + "px");
	                    $(element.find('.smart-table-cell-template')).html('').append(input).append(icon);
	                }

	                switch (scope.column.uiType) {
	                    case 'editable':
	                        switch (scope.column.attributes.type) {
	                            case 'number':
	                                setTimeout(function () {
	                                    var tmpVal;
	                                    if (isRegionalSettingEnabled) {
	                                        try {
	                                            element.find('input').attr('type', 'text');
	                                            var mDec = scope.column.attributes.minmaxprecisionfilter != undefined && scope.column.attributes.minmaxprecisionfilter.split(':')[1] != '' ? scope.column.attributes.minmaxprecisionfilter.split(':')[1] : MaxPrecessionValue;
	                                            element.find('input').autoNumeric('init', { mDec: mDec });
	                                        }
	                                        catch (error) {
	                                            console.log("Error in number init. " + scope.column.field);
	                                        }
	                                    }
	                                    else if (angular.isDefined(scope.column.attributes.minmaxprecisionfilter)) {
	                                        var arrDecimalSplits;

	                                        element.find('input').on('keydown', function (e) {
	                                            arrDecimalSplits = $(this).val().split('.');

	                                            if (arrDecimalSplits.length > 1) {
	                                                if (arrDecimalSplits[arrDecimalSplits.length - 1].length >= scope.column.attributes.minmaxprecisionfilter.split(':')[1] && ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105))) {
	                                                    e.preventDefault();
	                                                    return false;
	                                                }
	                                            }
	                                            else if (scope.column.attributes.minmaxprecisionfilter.split(':')[0] == 0 && e.keyCode == 190) {
	                                                e.preventDefault();
	                                                return false;
	                                            }
	                                        });
	                                    }

	                                    element.find('input').on('keyup', function (e) {
	                                        if (isRegionalSettingEnabled) {
	                                            try {
	                                                tmpVal = $(this).autoNumeric('get') * 1;
	                                            }
	                                            catch (error) {
	                                                console.log("Error in number format. " + scope.column.field);
	                                            }
	                                        }
	                                        else {
	                                            if (tmpVal == $(this).val()) {
	                                                return;
	                                            }
	                                            tmpVal = $(this).val();
	                                        }

	                                        if (scope.column.isRegUpdateCol) {
	                                            smartTableUtils.debounce.add(function () {
	                                                updateCell(scope.row.entity, scope.column.field, parseFloat(tmpVal));
	                                                //	cell change listener
	                                                angular.isFunction(smartTableScope.listeners.cellChange) && smartTableScope.listeners.cellChange({ entity: scope.row.entity, index: scope.rowIndex }, { colDef: scope.column, index: scope.columnIndex });
	                                                smartTableUtils.broadcast('rowDataChange', { rowIndex: scope.rowIndex, smartTableId: smartTableScope.smartTableId });
	                                            }, 250, false);
	                                        }
	                                    });
	                                });
	                                break;

	                            case 'autocomplete':
	                                var filterKeys = scope.column.attributes.filterkeys ? scope.column.attributes.filterkeys : ['title'];
	                                var optionFormat = scope.column.attributes.optionformat ? scope.column.attributes.optionformat : '{title}';
	                                var displayFormat = scope.column.attributes.displayformat ? scope.column.attributes.displayformat + '' : '{title}';

	                                setTimeout(function () {
	                                    var serviceObj = scope.column.attributes.serviceObj;
	                                    var tmpVal = oldCellValue;

	                                    element.find('input').on('keyup', function (e) {
	                                        if (angular.isDefined(tmpVal) && $(this).val().trim().length > 0 && tmpVal.trim() == $(this).val().trim()) {
	                                            return;
	                                        }

	                                        tmpVal = $(this).val();

	                                        if ([37, 38, 39, 40].indexOf(e.keyCode) > -1) {
	                                            return;
	                                        }

	                                        //	cell change listener
	                                        angular.isFunction(smartTableScope.listeners.cellChange) && smartTableScope.listeners.cellChange({ entity: scope.row.entity, index: scope.rowIndex }, { colDef: scope.column, index: scope.columnIndex }, { value: tmpVal });

	                                        if (angular.isDefined(tmpVal) && tmpVal.trim().length == 0 && !scope.column.attributes.populateListOnFocus) {
	                                            return;
	                                        }

	                                        smartTableUtils.debounce.add(function () {
	                                            if (serviceObj != undefined) {
	                                                var req = {
	                                                    method: serviceObj.method === "POST" ? "POST" : "GET",
	                                                    url: serviceObj.url,
	                                                    params: JSON.parse(JSON.stringify(serviceObj.param).replace("@term", tmpVal)),
	                                                    timeout: 120000,
	                                                    headers: {
	                                                        "Content-Type": "application/json",
	                                                        "UserExecutionContext": JSON.stringify(APPCONSTANTS.userPreferences.UserBasicDetails)
	                                                    }
	                                                };
	                                                if (req.method == "POST") {
	                                                    req.data = JSON.parse(JSON.stringify(serviceObj.param).replace("@term", tmpVal));
	                                                    delete req.params;
	                                                }
	                                                httpService.directhttp(req).then(function (response) {
	                                                    if (serviceObj.CallbackObj) {
	                                                        response = serviceObj.CallbackObj(response, scope.column.field)
	                                                    }

	                                                    var resp = [];

	                                                    if (typeof response === "string") {
	                                                        response = JSON.parse(response);
	                                                    }

	                                                    if (serviceObj.isFlatArray) {
	                                                        _.each(response, function (x, index) {
	                                                            var obj = {};
	                                                            obj["name"] = x;
	                                                            obj["code"] = x;
	                                                            resp.push(obj);
	                                                        });
	                                                    }
	                                                    else {
	                                                        _.each(response, function (obj) {
	                                                            var mapperObj = (serviceObj.isObjectArray) ? obj : {};
	                                                            _.each(serviceObj.mapper, function (mapper) {
	                                                                var mapperstri = '';
	                                                                if (angular.isArray(mapper['toBeMapped'])) {
	                                                                    var mapperkey = mapper.key;
	                                                                    _.each(mapper['toBeMapped'], function (res) {
	                                                                        if (mapperkey != undefined && mapperkey == 'email' && res == 'EmailAddress') {
	                                                                            mapperstri += "</br>" + obj[res] + " ";
	                                                                        }
	                                                                        else {
	                                                                            mapperstri += obj[res] + " ";
	                                                                        }
	                                                                    });
	                                                                    mapperstri.trim();
	                                                                }
	                                                                else {
	                                                                    mapperstri = obj[mapper['toBeMapped']];
	                                                                }
	                                                                mapperObj[mapper['key']] = mapperstri;
	                                                            });
	                                                            _.each(serviceObj.staticValues, function (item) {
	                                                                mapperObj[item['key']] = item['value'];
	                                                            });
	                                                            resp.push(mapperObj);
	                                                        });
	                                                    }

	                                                    if (element.find('input').devbridgeAutocomplete()) {
	                                                        element.find('input').devbridgeAutocomplete().setLookup(getFormattedData(resp, displayFormat));
	                                                    }
	                                                    else {
	                                                        element.find('input').devbridgeAutocomplete({
	                                                            filterKeys: filterKeys,
	                                                            optionFormat: optionFormat,
	                                                            displayFormat: displayFormat,
	                                                            lookup: getFormattedData(resp, displayFormat),
	                                                            width: scope.column.width,
	                                                            minChars: scope.column.attributes.populateListOnFocus ? 0 : 1,
	                                                            onSelect: function (suggestion) {
	                                                                selectedOption = suggestion;
	                                                                isRenderingToBeSkipped = true;
	                                                                element.find('input').devbridgeAutocomplete().setLookup([]);
	                                                                //	Option select listener
	                                                                angular.isFunction(smartTableScope.listeners.optionSelect) && smartTableScope.listeners.optionSelect({ entity: scope.row.entity, index: scope.rowIndex }, { colDef: scope.column, index: scope.columnIndex }, { value: tmpVal, option: selectedOption });
	                                                                element.trigger('focus');
	                                                            }
	                                                        });
	                                                    }

	                                                    if (resp.length == 1 && scope.column.attributes.populateListOnFocus) {
	                                                        try {
	                                                            element.find('input').devbridgeAutocomplete().onSelect(0);
	                                                        }
	                                                        catch (e) { }
	                                                    }
	                                                    else {
	                                                        //	Options change listener
	                                                        angular.isFunction(smartTableScope.listeners.optionsChange) && smartTableScope.listeners.optionsChange({ entity: scope.row.entity, index: scope.rowIndex }, { colDef: scope.column, index: scope.columnIndex }, { value: tmpVal, options: response });
	                                                    }

	                                                }, function () {
	                                                });
	                                            }
	                                        }, 250, false);
	                                    });

	                                    if (scope.column.attributes.populateListOnFocus) {
	                                        var triggerKeyUpOnfocus = function () {
	                                            if (!isInputFieldFocused) {
	                                                var tmpEvent = $.Event("keyup", {
	                                                    keyCode: 32
	                                                });
	                                                element.find('input').trigger(tmpEvent);
	                                                isInputFieldFocused = true;
	                                            }
	                                        };

	                                        element.find('input').on('click', function (e) {
	                                            triggerKeyUpOnfocus();
	                                        });

	                                        if (element.find('input:focus').length > 0) {
	                                            triggerKeyUpOnfocus();
	                                        }
	                                    }
	                                });
	                                break;

	                            case 'date':
	                                setTimeout(function () {
	                                    element.find('input').on('keyup', function (e) {
	                                        selectedDate = $(this).val();
	                                    });

	                                    element.find('input').daterangepicker({
	                                        singleDatePicker: true,
	                                        showDropdowns: true,
	                                        locale: {
	                                            format: scope.column.attributes.format ? (scope.column.attributes.format).toUpperCase() : 'MM/DD/YYYY'
	                                        },
	                                        minDate: scope.column.attributes.min ? scope.column.attributes.min : null,
	                                        maxDate: scope.column.attributes.max ? scope.column.attributes.max : null,
	                                        autoUpdateInput: false
	                                    }, function (startDate, endDate) {
	                                        updateDate(startDate);
	                                    }).on('apply.daterangepicker', function (e, picker) {
	                                        updateDate(picker.startDate);
	                                    });
	                                });
	                                break;
	                        }
	                        break;

	                    case 'dropdown':
	                        if (angular.isFunction(smartTableScope.listeners.optionSelect)) {
	                            setTimeout(function () {
	                                element.find('select').on('change', function () {
	                                    for (var i = 0; i < scope.column.attributes.options.length; i++) {
	                                        if ($(this).val() == scope.column.attributes.options[i][scope.column.attributes.idKey] + '') {
	                                            // Options change listener
	                                            smartTableScope.listeners.optionSelect({ entity: scope.row.entity, index: scope.rowIndex }, { colDef: scope.column, index: scope.columnIndex }, { value: scope.column.attributes.options[i] });
	                                            break;
	                                        }
	                                    }
	                                });
	                            });
	                        }
	                        break;

	                    case 'taxesPopup':
	                        setTimeout(function () {
	                            var tmpVal;
	                            if (isRegionalSettingEnabled) {
	                                try {
	                                    element.find('input').attr('type', 'text');
	                                    element.find('input').autoNumeric('init');
	                                }
	                                catch (error) {
	                                    console.log("Error in number init. " + scope.column.field);
	                                }
	                            }
	                            else if (angular.isDefined(scope.column.attributes.minmaxprecisionfilter)) {
	                                var arrDecimalSplits;

	                                element.find('input').on('keydown', function (e) {
	                                    arrDecimalSplits = $(this).val().split('.');

	                                    if (arrDecimalSplits.length > 1) {
	                                        if (arrDecimalSplits[arrDecimalSplits.length - 1].length >= scope.column.attributes.minmaxprecisionfilter.split(':')[1] && ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105))) {
	                                            e.preventDefault();
	                                            return false;
	                                        }
	                                    }
	                                    else if (scope.column.attributes.minmaxprecisionfilter.split(':')[0] == 0 && e.keyCode == 190) {
	                                        e.preventDefault();
	                                        return false;
	                                    }
	                                });
	                            }

	                            element.find('input').on('keyup', function (e) {
	                                if (isRegionalSettingEnabled) {
	                                    try {
	                                        tmpVal = $(this).autoNumeric('get') * 1;
	                                    }
	                                    catch (error) {
	                                        console.log("Error in number format. " + scope.column.field);
	                                    }
	                                }
	                                else {
	                                    if (tmpVal == $(this).val()) {
	                                        return;
	                                    }
	                                    tmpVal = $(this).val();
	                                }

	                                if (scope.column.isRegUpdateCol) {
	                                    smartTableUtils.debounce.add(function () {
	                                        updateCell(scope.row.entity, scope.column.field, parseFloat(tmpVal));
	                                        //	cell change listener
	                                        angular.isFunction(smartTableScope.listeners.cellChange) && smartTableScope.listeners.cellChange({ entity: scope.row.entity, index: scope.rowIndex }, { colDef: scope.column, index: scope.columnIndex });
	                                        smartTableUtils.broadcast('rowDataChange', { rowIndex: scope.rowIndex, smartTableId: smartTableScope.smartTableId });
	                                    }, 250, false);
	                                }
	                            });
	                        });
	                        break;
	                }

	                smartTableScope.lastActiveCell = {
	                    rowIndex: scope.rowIndex,
	                    columnIndex: scope.columnIndex
	                };

	                isInEditMode = true;
	            };


	            element.on('focus', onFocus);

	            element.on('click', function (e) {
	                if (scope.column.uiType == 'popup' && scope.column.enableCellEdit && angular.isFunction(scope.column.cellEditableCondition) && scope.column.cellEditableCondition({ row: scope.row, col: { colDef: scope.column }, grid: { rows: smartTableScope.smartTableConfig.data }, cellElement: element }) && scope.column.isRegClickCol) {
	                    smartTableUtils.debounce.add(function () {
	                        window.isPopupOpenedByUIGridCompatibleElement = true;
	                        //	cell click listener
	                        angular.isFunction(smartTableScope.listeners.cellClick) && smartTableScope.listeners.cellClick({ entity: scope.row.entity, index: scope.rowIndex }, { colDef: scope.column, index: scope.columnIndex });
	                    }, 100);
	                }
	            });

	            var onFocusCell = smartTableUtils.on('focusCell', function (e) {
	                if (e.rowIndex == scope.rowIndex && e.columnIndex == scope.columnIndex && e.smartTableId == smartTableScope.smartTableId) {
	                    element.trigger('focus');
	                }
	            });

	            var onRowDataChange = smartTableUtils.on('rowDataChange', function (e) {
	                if (e.rowIndex == scope.rowIndex && e.smartTableId == smartTableScope.smartTableId) {
	                    //	skip updating the field since being already in edit mode
	                    if (!isInEditMode) {
	                        init(true, true);
	                    }
	                }
	            });

	            var onDataChange = smartTableUtils.on('dataChange', function (e) {
	                if (e.smartTableId == smartTableScope.smartTableId && e.updateCell) {
	                    init(true, true);
	                }
	            });

	            scope.$on('$destroy', function () {
	                // console.log('smart-cell scope destroyed');
	                onCellDataAndColDefChange();
	                onFocusCell();
	                onRowDataChange();
	                onDataChange();
	                element.off('keydown', onElementKeyDown);
	            });
	        },
	        template: '<span class="smart-table-cell-text"><span class="smart-table-cell-template"></span></span>'
	    };
	}]);
})();
